import { DragDropModule } from "@angular/cdk/drag-drop";
import { FlatTreeControl } from "@angular/cdk/tree";
import { CommonModule, DatePipe, DecimalPipe } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  signal,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormsModule, NgForm } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIcon } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTabChangeEvent, MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from "@angular/material/tree";
import { ModalMonitorRealtimeComponent } from "./modal-monitor-realtime/modal-monitor-realtime.component";
import {
  CompanyAttributes,
  DocumentClassAttributes,
  DocumentTypeAttributes,
  ExpenseAttributes,
  OrderAttributes,
  TripAttributes,
  VisitAttributes,
} from "@albatrosdeveloper/ave-models-package";

import { DateHourPipe } from "app/pipes/formated-date.pipe";
import { ModalMapComponent } from "../../reports/visits/visit-report/modal-map/modal-map.component";
import { ImageCarouselComponent } from "../../reports/visits/visit-report/modal-image/modal-image.component";
import { MatBadgeModule } from "@angular/material/badge";

import { CompanyService } from "../../configuration/company/company.service.service";
import { LoadCalculationModeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/load-calculation-mode.enum";
import { MonedaPipe } from "app/pipes/moneda.pipe";
import { OrdersListService } from "../../sales/order-list-components/order-list.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoadTableListComponent } from "../table-load-list/table-load-list.component";
import { TableLoadListSmartGridComponent } from "../table-load-list/table-load-list-smart-grid.component";
import { SummaryMaterialComponent } from "../../assistant/delivery/loads/components/summary-material/summary-material.component";
import { DocumentTypeService } from "../../document/document-type/document-type.service";
import { IUpdateTrip } from "../../sales/trip/interfaces/updateTrip";
import { TripRouteService } from "../../sales/trip/trip.service";
import { SharedTripEditModalComponent } from "../../../shared/components/shared-trip-edit-modal/shared-trip-edit-modal.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { firstValueFrom, lastValueFrom, Observable, Subject, Subscription, take, takeUntil } from "rxjs";
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseVerticalNavigationComponent } from '@fuse/components/navigation/vertical/vertical.component';
import { UserMasterService } from "../../routing/sub-routes/sub-route-collaborator/user_master.service";
import VehicleAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/transport/vehicle/vehicle.entity";
import { VechicleService } from "../../transport/vechicle/vehicle.service";
import { PaymentTableListComponent } from "../payment-load-list/payment-load-list";
import {
  validateOrdersByAction,
  validateOrdersByActionForPayment,
} from "app/utils/document-class-validation";
import OrderPaymentAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/process/order-payment/order-payment.entity";
import { OrderPaymentIntegratosServicesService } from "../../collections/payment-management/payment-management-integrator.service";
import { PrincipalScreenService } from "../principal-screen/principal-screen.service";
import { PaymentOrderService } from "../../collections/payment-management/payment-management.service";
import { TripService } from "../../reports/visits/visit-report/visit-report.service";
import { IDetailOrden } from "../table-load-list/interfaces/detailOrderUpdate.interface";
import { getCode } from "app/utils/method";
import { SalesDistributionService } from "../../assistant/sales-distribution/sales-distribution.service";
import { UpdateOrderService } from "../../sales/update-order/update-order.service";
import { TransportLoadListComponent } from "../transport-load-list/transport-load-list.component";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { OrderListTableComponent } from "../order-list-table/order-list-table.component";
import { CreditNoteDialogComponent } from "../payment-load-list/credit-note/credit-note.component";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { WindowStateService } from "./monitor-map/monitor-map.service";
import { MovableWindowComponent } from "./monitor-map/monitor-map.component";
import { AgendaMapComponent } from "../agenda-view/agenda-map/agenda-map.component";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { ClientMaterialSummary, ClientOrder, groupMaterialsByClient, GroupedMaterialWithCustomers } from "./interfaces/material-group-partner";
import { MonitorClientMaterialSummaryComponent } from "./monitor-client-material-summary/monitor-client-material-summary.component";
import { LiquidationsComponent } from "./liquidations/liquidations.component";
import { LiquidationService } from "./liquidation.service";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { UnitOfMeasureEnum } from "app/common/enums/unit-of-measure.enum";
import { PaymentReasonEnum } from "app/common/enums/payment-reason.enum";
import { SortDirectionEnum } from "app/common/enums/sort-direction.enum";
import { TRIP_STATUS_CONFIG, TRIP_STATUS_LIST, TripStatus } from "app/common/enums/trip-status.enum";

import { ChargePartnerExport } from "../../assistant/delivery/loads/exports/charge-partnert.export";
import { UserRouteDisplayComponent } from 'app/shared/components/user-route-display/user-route-display.component';
import { BusinessPartnerDisplayComponent } from 'app/shared/components/business-partner-display/business-partner-display.component';
import { TripStatusBadgeComponent } from 'app/shared/components/trip-status-badge/trip-status-badge.component';
import { TripStatusIconComponent } from 'app/shared/components/trip-status-icon/trip-status-icon.component';
import { ExportDialogComponent, ExportFileFormat, ExportOptions } from "app/layout/export-overlay";
import { CHARGE_PARTNER_EXPORT_ID, CHARGE_PARTNER_TITLE, DELIVERY_PARTNER_EXPORT_ID, DELIVERY_PARTNER_TITLE, CURRENCYFIELDS, FORMATTER } from "../../assistant/delivery/loads/exports/charge-partner.constants";
import { WorkCourseCustomerExport } from "../../assistant/delivery/loads/exports/work-course-customer.exports";
import { WORK_COURSER_CUSTOMER_TITLE } from "../../assistant/delivery/loads/exports/work-course-customer.constants";
import { WorkProgressMaterialItem, WorkProgressMaterialsResponse } from "./interfaces/work-progress-material.interface";
import { WorkProgressMaterialSummaryComponent } from "./work-progress-material-summary/work-progress-material-summary.component";
import { GroupedPayment } from "../../../../shared/interfaces/payment.interface";
import { PaymentMethodsTabComponent } from "../../../../shared/components/payment-methods-tab/payment-methods-tab.component";
import { MaterialHistoryComponent } from "../../assistant/delivery/loads/components/material-history/material-history.component";
import { ModalDistributionComponent } from "./modal-distribution/modal-distribution.component";
import { DocumentNavigationComponent } from "app/common/components/document-navigation/document-navigation.component";
import { DistributionGroupedByTrip } from "./interfaces/distribution.interface";
import { RoutesDetailByBusinessPartnerVehicleComponent } from "../../modals/routes-detail-by-business-partner-vehicle/routes-detail-by-business-partner-vehicle/routes-detail-by-business-partner-vehicle.component";
import { MapModalComponent } from "app/shared/components/map-modal/map-modal.component";
import { MapModalInputData } from "app/shared/components/map-modal/models/map-modal.interface";
import { MapFilterTypeEnum, MapModalTypeEnum, MonitorDocumentTypeEnum } from "app/shared/components/map-modal/models/map-modal.enum";
import { DocumentTypeMonitor } from "./monitor-routes.interface";
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';
import { DownloadResumeRoutesMonitorComponent } from "app/modules/shared/components/download-resume-routes-monitor/download-resume-routes-monitor.component";
import { PinnedTripsService } from "../principal-screen/pinned-trips.service";
import { PurgeTripDialogComponent } from "./modal-purge-trip/modal-purge-trip.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { IPagination, IPaginationResult } from "app/common/interfaces";
import { ExpenseService } from "../../payment-master/expense/expense-list/expense-list.service";
import { ExpenseLoadListComponent } from "../expense-load-list/expense-load-list.component";
import { ExpenseTotalsTabComponent } from "../expense-totals-tab/expense-totals-tab.component";
import { SmartGridComponent, ColDef, GridConfig, GridReadyEvent } from 'app/shared/components/smart-grid';
import { GeoIconCellRendererComponent } from './components/visits-grid/cell-renderers/geo-icon-cell-renderer.component';
import { VisitImagesCellRendererComponent } from './components/visits-grid/cell-renderers/visit-images-cell-renderer.component';
import { BusinessPartnerCellRendererComponent } from './components/visits-grid/cell-renderers/business-partner-cell-renderer.component';
import { DocumentNavigationCellRendererComponent } from './components/visits-grid/cell-renderers/document-navigation-cell-renderer.component';
import { DateTimeCellRendererComponent } from './components/visits-grid/cell-renderers/datetime-cell-renderer.component';
import { BooleanYesNoCellRendererComponent } from './components/visits-grid/cell-renderers/boolean-yesno-cell-renderer.component';
import { ReasonCellRendererComponent } from './components/visits-grid/cell-renderers/reason-cell-renderer.component';

// Pedidos por Cliente Cell Renderers
import { OrderDocumentCellRendererComponent } from './cell-renderers/order-document-cell-renderer.component';
import { BusinessPartnerCellRendererComponent as OrderBusinessPartnerCellRendererComponent } from './cell-renderers/business-partner-cell-renderer.component';
import { DeliveryDateTimeCellRendererComponent } from './cell-renderers/delivery-datetime-cell-renderer.component';
import { OrderActionsCellRendererComponent } from './cell-renderers/order-actions-cell-renderer.component';
import { MaterialDetailsCellRendererComponent } from './cell-renderers/material-details-cell-renderer.component';
import { QuantityUMPCellRendererComponent } from './cell-renderers/quantity-ump-cell-renderer.component';
import { DecimalCellRendererComponent } from 'app/shared/components/smart-grid';
import { BehaviorSubject } from 'rxjs';
import { OrderStatusERPEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/order-status-erp.enum";
import { UnitMeasureDisplayComponent } from "app/shared/components/unit-measure-display/unit-measure-display.component";
import { UnifiedLoadDocsChipComponent } from "app/shared/components/unified-load-docs-chip/unified-load-docs-chip.component";
import { AuditLogViewerService } from "app/shared/services/audit-log-viewer.service";
import { AUDIT_LOG_COLLECTIONS } from "app/shared/components/audit-log-viewer/audit-log-collections.constants";
import { PermissionDirective } from "app/core/permission";
import { SALES_MONITOR_PERMISSIONS } from "app/common/constants/permission";

interface TripNode extends Omit<TripAttributes, 'id'> {
  id: string | number; // obligatorio para nodos padres y viajes
  children?: TripNode[];
  auxUniqueStatus?: { id: number; color: string; info: string };
  auxUniqueFunction?: { id: string; name: string; model: string };
  isStatusGroup?: boolean;
  isFunctionGroup?: boolean;
}
interface TripFlatNode extends Omit<TripAttributes, 'id'> {
  id: string | number; // obligatorio
  expandable: boolean;
  levelTree: number;
  auxUniqueStatus?: { id: number; color: string; info: string };
  auxUniqueFunction?: { id: string; name: string; model: string };
  isStatusGroup?: boolean;
  isFunctionGroup?: boolean;
  children?: TripNode[];
}

interface CategoryNode {
  children?: CategoryNode[];
}

interface CategoryFlatNode {
  expandable: boolean;
  levelTree: number;
}

interface statusDocument {
  countDocument: number;
  notAllowedSync: number; // los que no tienen la variable statusERP
  notSynchronization: OrderStatusERPEnum;  // statusERP = OrderStatusERPEnum.ORDER_ERROR_ERP, OrderStatusERPEnum.ORDER_ERROR
  loadSynchronization: OrderStatusERPEnum; // statusERP = OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE, OrderStatusERPEnum.ORDER_RECEIVED, OrderStatusERPEnum.ORDER_PENDING, OrderStatusERPEnum.ORDER_SEND
  synchronization: number;
}

interface statusDocumentDelivery {
  countDocument: number;
  delivered: number;
  notDelivered: number;
  loadDelivered: number;
}

interface IStatusRoute {
  countDocument: number;
  visitValid: number;
  visitNotValid: number;
}

// Visits Grid Interfaces
interface VisitImage {
  image: {
    link: string;
  };
}

interface GeoIconCellRendererParams {
  onOpenModal: (detail: VisitAttributes, type: string) => void;
}

interface VisitImagesCellRendererParams {
  onOpenCarousel: (images: VisitImage[]) => void;
}

interface DateTimeCellRendererParams {
  format?: string;
}

@Component({
  selector: "app-monitor-routes",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatIcon,
    MatSortModule,
    MatButtonModule,
    MatTabsModule,
    MatMenuModule,
    MatSlideToggle,
    FormsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    DragDropModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatDialogModule,
    MatExpansionModule,
    DateHourPipe,
    MatBadgeModule,
    MonedaPipe,
    LoadTableListComponent,
    TableLoadListSmartGridComponent,
    SummaryMaterialComponent,
    PaymentTableListComponent,
    TransportLoadListComponent,
    NgSelectModule,
    OrderListTableComponent,
    MovableWindowComponent,
    AgendaMapComponent,
    DecimalFormatPipe,
    MonitorClientMaterialSummaryComponent,
    LiquidationsComponent,
    WorkProgressMaterialSummaryComponent,
    PaymentMethodsTabComponent,
    PermissionDirective,
    DocumentNavigationComponent,
    UserRouteDisplayComponent,
    BusinessPartnerDisplayComponent,
    TripStatusBadgeComponent,
    TripStatusIconComponent,
    RoutesDetailByBusinessPartnerVehicleComponent,
    DownloadResumeRoutesMonitorComponent,
    ExpenseLoadListComponent,
    ExpenseTotalsTabComponent,
    UnitMeasureDisplayComponent,
    UnifiedLoadDocsChipComponent,
    SmartGridComponent,
    OrderDocumentCellRendererComponent,
    OrderBusinessPartnerCellRendererComponent,
    DeliveryDateTimeCellRendererComponent,
    OrderActionsCellRendererComponent,
    MaterialDetailsCellRendererComponent,
    QuantityUMPCellRendererComponent,
    DecimalCellRendererComponent
  ],
  templateUrl: "./monitor-routes.component.html",
  styleUrl: "./monitor-routes.component.scss",
  providers: [{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }, ChargePartnerExport, WorkCourseCustomerExport],
})
export class MonitorRoutesComponent {
  StatusEnum = StatusEnum
  readonly PERMISSIONS = SALES_MONITOR_PERMISSIONS;
  OrderStatusERPEnum = OrderStatusERPEnum
  DocumentTypeEnum = DocumentTypeEnum
  UnitOfMeasureEnum = UnitOfMeasureEnum
  PaymentReasonEnum = PaymentReasonEnum
  SortDirectionEnum = SortDirectionEnum

  // Navigation state for conditional styling
  isNavOpened: boolean = true;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  @ViewChild(AgendaMapComponent) agendaMap: AgendaMapComponent;
  @ViewChild("sortMainTable") sortMainTable: MatSort;
  @ViewChild("sortMainCharge") sortMainTableCharge: MatSort;
  // REMOVED: @ViewChild("sortSubCharge") - now using smart-grid sorting
  @ViewChild("sortMainDocument") sortTableMainDocument: MatSort;
  @ViewChild("sortSubDocument") sortTableSubDocument: MatSort;
  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("editModalDistribution") editModalDistribution!: TemplateRef<any>;
  @ViewChild("paginarionMaterial", { static: false })
  paginatorMaterial!: MatPaginator;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild("updateDialog") updateDialog!: TemplateRef<any>;
  @ViewChild("editAdvert") editAdvert!: TemplateRef<any>;
  @ViewChild("viewDocumentModal") viewDocumentModal!: TemplateRef<any>;
  @ViewChild('soldToEmptyDocument') soldToEmptyDocument!: TemplateRef<any>;
  soldToEmptyDialogRef: MatDialogRef<any> | null = null;
  @Input() modeTreeMonitor: "statusTrip" | "functionTrip" | null = null;
  @Input() pinnedTripIds: Set<number> = new Set();
  @Input() showOnlyPinned: boolean = false;
  modeTree: 'statusTrip' | 'functionTrip' | null = null;
  private transformer = (node: TripNode, levelTree: number): TripFlatNode => {
    return {
      ...node,
      expandable: !!(node.children && node.children.length > 0),
      levelTree: levelTree,
      isStatusGroup: node.isStatusGroup,
      isFunctionGroup: node.isFunctionGroup, // NUEVO
      children: node.children,
    };
  };
  treeControl = new FlatTreeControl<TripFlatNode>(
    (node) => node.levelTree,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this.transformer,
    (node) => node.levelTree,
    (node) => node.expandable,
    (node) => node.children
  );

  //  Table pagination
  pageSize: number = 50;
  pageIndex: number = 0;
  totalItems: number;

  // Paginacion Material
  pageSizeMaterial: number = 50;
  pageIndexMaterial: number = 0;
  totalItemsMaterial: number;
  searhMaterial: string = "";
  sortMaterial: string = SortDirectionEnum.ASC;

  //paginado para agrupado por clientes
  deliveryTotalItems: number;
  chargeTotalItems: number;
  activeTabIndex: number = 0;

  //Currency
  currency: string | null = " ";
  // Editar viaje
  currentUpdateTrip: IUpdateTrip;
  parameterIdForVehicles: string[] = [];
  dialogReEdit: MatDialogRef<any>;

  @ViewChild("viewDownloadResumeModal") viewDownloadResumeModal!: TemplateRef<any>;

  dialogRefDownloadResumeModal: MatDialogRef<any>;
  tripIdDownload: number;

  statusList = [];

  currentPage: number = 1;
  pageSizeLoan: number = 100;
  searchDocument: string = "";

  currentParentTab: number = 0;
  selectedTabIndex = 1; // 0 = Pedidos, 1 = Resumen Material

  // Para el agrupado por clientes
  activeTable: "delivery" | "charge" = "delivery";

  subTabActiveIndex = 1;
  workInProgressSubTabsIndex = 0;

  // Data busqueda
  @Input() fetchAllWithCount: (
    pageSize: number,
    pageIndex: number,
    sortActive: any,
    selectedDate?: any,
    selectedDateEnd?: any,
    tripId?: number
  ) => void;
  @Input() dataSource: any;
  @Input() search: any;
  @Input() companyList: CompanyAttributes[] = [];

  @Output() openPinnedModal = new EventEmitter<void>();
  documentClassesList: DocumentClassAttributes[] = [];
  dataSourceRouteTree = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  expenseListActive: boolean = false;
  showExpenseTab: boolean = false;

  // Tabla principal
  public dataSourceRoute: MatTableDataSource<any>;
  private routeDataArray: TripAttributes[] = [];
  public displayColums: string[] = [
    "det",
    "pin",
    "travel",
    "info",
    // "route",
    // "user",
    // "businessPartner",
    "vehicle",
    "start",

    "end",
    "documents",
    "status",
    "assignedLoad",
    "noStops",
    "hasUnifiedLoadDocs",
    "realTimeMonitor",
    "actions",
  ];
  // TODO: verify this typing of trip attributes response from api
  public selectedMR: TripAttributes & { [key: string]: any } | null = null;
  public userRequestedMap = false;
  loanUnit: string = "";
  public dataSourceItemsCharge = new MatTableDataSource([]);
  // REMOVED: dataSourceMaterilaCharge - now using smart-grid row expansion
  public dataSourceItemsDocuments = new MatTableDataSource([]);
  public dataSourceItemsDocumentsExport = new MatTableDataSource([]);
  public dataSourcePayments = new MatTableDataSource([]);
  totalPaying: number = 0;
  totalOverPayment: number = 0;

  // Variables subDatos Carga
  public modeResume = false;

  // REMOVED: displayColumsCharge - now using smart-grid column definitions

  public displayColumsChargeGeneral: string[] = [
    "det",
    "businesspartner",
    "noDocument",
    "total",
    "actions",
  ];

  public dataSourceDeliveryLoan = new MatTableDataSource([]);
  public dataSourceTransport = new MatTableDataSource([]);

  public dataSourceDeliveryMaterials = new MatTableDataSource([]);
  public dataSourceDeliveryPartners = new MatTableDataSource([]);

  // Work Progress Materials
  public workProgressMaterialData: WorkProgressMaterialsResponse | null = null;
  public isLoadingWorkProgressMaterials = false;

  public selectedCharge: any | null = null;
  public dataSourceItemsSubCharge = new MatTableDataSource([]);

  // Smart Grid configurations for Pedidos por Cliente
  chargeOrdersColumnDefs: ColDef<any>[] = [];
  materialDetailsColumnDefs: ColDef<any>[] = [];
  chargeOrdersGridConfig: GridConfig<any> = {
    rowIdField: "_id",
    pagination: {
      enabled: false,
    },
    sorting: {
      enabled: true,
      mode: "local",
      multiColumn: false,
    },
    selection: {
      enabled: false,
    },
    search: {
      enabled: false,
    },
    columnFilters: {
      enabled: true,
      mode: "local",
      showFilterIcon: true,
      trigger: "click",
    },
    rowExpansion: {
      enabled: true,
      multipleExpand: false,
      expandOnClick: false,
    },
    styling: {
      density: "comfortable",
      maxHeight: "60vh",
      cellPaddingY: "0px",
    },
    responsive: {
      enabled: true,
    },
    settingsPanel: {
      enabled: false,
    },
  };

  materialDetailsGridConfig: GridConfig<any> = {
    rowIdField: "_id",
    pagination: {
      enabled: false,
    },
    sorting: {
      enabled: true,
      mode: "local",
      multiColumn: false,
    },
    selection: {
      enabled: false,
    },
    search: {
      enabled: false,
    },
    columnFilters: {
      enabled: false,
    },
    rowExpansion: {
      enabled: false,
    },
    styling: {
      density: "compact",
      maxHeight: "400px",
      cellPaddingY: "0px",
    },
    responsive: {
      enabled: true,
    },
    settingsPanel: {
      enabled: false,
    },
  };

  @ViewChild("viewRoutesByVehicleIdModal") viewRoutesByVehicleIdModal!: TemplateRef<any>;

  dialogRefRoutesByVehicleIdModal: MatDialogRef<any>;

  public displayGruopUnified: string[] = [
    "det",
    "noDtn",
    // "warning"
  ];

  public displayColumsDistributionMain: string[] = [
    "det",
    "material",
    //"noDtn",
    "missing",
    "spare",
    "totalUMB",
    "totalUMP",
  ];

  public displayColumsDistributionItems: string[] = [
    "isNew",
    "noDto",
    "client",
    "note",
    "warehouse",
    "soldQuantity",
    "unitPrice",
    "subTotal",
    "totalSurcharges",
    "totalDiscounts",
    "tax",
    "total",
  ];

  displayedColumnsInnerDetail: string[] = [
    "view",
    "paymentMethod",
    "bank",
    "operationNumber",
    "overPayment",
    "paying",
  ];
  // Columnas para la vista árbol
  displayColumsTree: string[] = [
    "det",
    "pin",
    "travel",
    "info",
    "vehicle",
    "start",
    "end",
    "documents",
    "status",
    "assignedLoad",
    "noStops",
    "hasUnifiedLoadDocs",
    "realTimeMonitor",
    "actions",
  ];

  dataSourceDistributionDetail = new MatTableDataSource([]);
  dataSourceDistributionItemDetail = new MatTableDataSource([]);
  selectGroupUnified;
  selectItemDistribution;
  deliveryGroupUnified = new MatTableDataSource([]);
  deliveryGroupMaterialUnified = new MatTableDataSource([]);
  deliveryUnifieldEditList: IDetailOrden[] = [];
  isSaveDistribution = false;
  dataSourceOrderLoan = new MatTableDataSource([]);
  detailOrderUnified = [];

  selectedVisits = [];
  selectedDelivery = [];

  //Datasource para los documentos en trabajo en curso
  public dataSourceItemsFact = new MatTableDataSource([]);
  public dataSourceItemsMerma = new MatTableDataSource([]);
  public dataSourceItemsDevo = new MatTableDataSource([]);
  public dataSourceExpenses = new MatTableDataSource<ExpenseAttributes>([]);
  totalItemsExpense: number = 0;
  tripIdExpense: number = 0;

  UMPActive: boolean = false;

  // Observable for UMPActive - reactive approach for Pedidos por Cliente grid
  private UMPActiveSubject$ = new BehaviorSubject<boolean>(false);
  public UMPActive$ = this.UMPActiveSubject$.asObservable();

  totalUnit: string = "";
  dataSourceItemsCharges = new MatTableDataSource([]);
  dataSourceChargePartners = new MatTableDataSource([]);
  dataSourceChargeMaterials = new MatTableDataSource([]);
  countCharge = 0;
  // REMOVED: displayColumsSubCharge - now using smart-grid column definitions for nested grid

  // Tab Documents
  public displayColumsDocument: string[] = [
    "det",
    "businesspartner",
    "ctnMaterials",
    "price",
    "load",
    "visits",
    "actions",
  ];

  // Tabla Principal document
  public displayColumsDocumentDetails: string[] = [
    "nroOrder",
    "nroView",
    "otherDocuments",
  ];

  public dataSourceDocumentsDetails = new MatTableDataSource([]);

  public isVisibleDetailsDoc = false;
  public isVisibleLoan = false;
  public isVisibleDelivery = false;
  public isVisibleVisit = false;
  deliveryUnified = 0;
  getCode = getCode;

  public selectedDocument: any | null = null;
  public dataSourceItemsSubDocuments = new MatTableDataSource([]);
  public groupDocuments: any[];
  documentTypeList: DocumentTypeAttributes[] = [];
  public selectDocumentGroup: any | null = null;
  // Tabla Sub document
  public displayColumsSubDocument: string[] = [
    "material",
    "price",
    "cntLoad",
    "reference",
    "type",
    "noDelivery",
    "noBilling",
  ];

  // Tabla de Recorrido
  public visitMade = 0;

  public dataSourceItemsRoutes: VisitAttributes[] = [];
  // Tabla Sub document
  public displayColumsRoutes: string[] = [
    "geo",
    "visitImages",
    "bPartner",
    "visit",
    "documentNumber",
    "startHour",
    "endHour",
    "duration",

    "wasTheVisitOnSite",
    "validVisit",
  ];

  // Smart Grid Configuration for Visits
  loadingVisits: boolean = false;

  visitsColumnDefs: ColDef<any>[] = [
    // 1. Geo Icon Column (Pinned Left)
    {
      colId: 'geo',
      headerName: '',
      minWidth: 60,
      width: 60,
      maxWidth: 60,
      sortable: false,
      filterable: false,
      pinned: 'left',
      lockPinned: true,
      cellRenderer: GeoIconCellRendererComponent,
      cellRendererParams: {
        onOpenModal: (detail: VisitAttributes, type: string) => this.openModalVisit(detail, type)
      } as GeoIconCellRendererParams,
      cellClass: 'text-center'
    },
    // 2. Visit Images Column (Pinned Left)
    {
      colId: 'visitImages',
      headerName: '',
      minWidth: 60,
      width: 60,
      maxWidth: 60,
      sortable: false,
      filterable: false,
      pinned: 'left',
      lockPinned: true,
      cellRenderer: VisitImagesCellRendererComponent,
      cellRendererParams: {
        onOpenCarousel: (images: VisitImage[]) => this.openImageCarousel(images)
      } as VisitImagesCellRendererParams,
      cellClass: 'text-center'
    },
    // 3. Business Partner Column
    {
      field: 'shipTo',
      headerName: 'Cliente',
      minWidth: 200,
      sortable: true,
      filterable: true,
      cellRenderer: BusinessPartnerCellRendererComponent,
      filterOptions: {
        valueExtractor: (item: VisitAttributes) => item.shipTo?.name,
        customFilterFn: (rowData: VisitAttributes, filterValue: string) => {
          return rowData.shipTo?.name === filterValue;
        }
      }
    },
    // 4. Visit Reason Column
    {
      field: 'reasonForVisit' as any,
      headerName: 'Motivo de Visita',
      minWidth: 150,
      sortable: true,
      filterable: true,
      cellRenderer: ReasonCellRendererComponent,
      filterOptions: {
        valueExtractor: (item: VisitAttributes) => item.reasonForVisit?.name
      }
    },
    // 5. Document Number Column
    {
      field: 'serials',
      headerName: 'N° Documento',
      minWidth: 150,
      sortable: true,
      filterable: true,
      cellRenderer: DocumentNavigationCellRendererComponent
    },
    // 6. Start Date/Time Column
    {
      field: 'dateTimeStart' as any,
      headerName: 'Hora Inicio',
      minWidth: 150,
      sortable: true,
      filterable: true,
      cellRenderer: DateTimeCellRendererComponent,
      filterOptions: {
        valueExtractor: (item: VisitAttributes) => {
          if (!item.dateTimeStart) return '';
          const date = new Date(item.dateTimeStart);
          return date.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          });
        },
        customFilterFn: (rowData: VisitAttributes, filterValue: string) => {
          const rowDate = rowData.dateTimeStart;
          if (!rowDate) return !filterValue;

          const rowDateObj = new Date(rowDate);
          const rowDateStr = rowDateObj.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          });

          return rowDateStr === filterValue;
        }
      }
    },
    // 7. End Date/Time Column
    {
      field: 'dateTimeEnd' as any,
      headerName: 'Hora Fin',
      minWidth: 150,
      sortable: true,
      filterable: true,
      cellRenderer: DateTimeCellRendererComponent,
      filterOptions: {
        valueExtractor: (item: VisitAttributes) => {
          if (!item.dateTimeEnd) return '';
          const date = new Date(item.dateTimeEnd);
          return date.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          });
        },
        customFilterFn: (rowData: VisitAttributes, filterValue: string) => {
          const rowDate = rowData.dateTimeEnd;
          if (!rowDate) return !filterValue;

          const rowDateObj = new Date(rowDate);
          const rowDateStr = rowDateObj.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          });

          return rowDateStr === filterValue;
        }
      }
    },
    // 8. Duration Column (already calculated in data)
    {
      field: 'duration' as any,
      headerName: 'Duración',
      minWidth: 100,
      sortable: true,
      filterable: false,
      cellClass: 'text-center'
    },
    // 9. Zone Flag Column (Was The Visit On Site)
    {
      field: 'wasTheVisitOnSite',
      headerName: 'En Zona',
      minWidth: 140,
      sortable: true,
      filterable: true,
      cellRenderer: BooleanYesNoCellRendererComponent,
      cellClass: 'text-center',
      filterOptions: {
        valueExtractor: (item: VisitAttributes) => item.wasTheVisitOnSite ? 'SI' : 'NO'
      }
    },
    // 10. Valid Visit Column
    {
      field: 'validVisit',
      headerName: 'Visita Válida',
      minWidth: 120,
      sortable: true,
      filterable: true,
      cellRenderer: BooleanYesNoCellRendererComponent,
      cellClass: 'text-center',
      filterOptions: {
        valueExtractor: (item: VisitAttributes) => item.validVisit ? 'SI' : 'NO'
      }
    }
  ];

  visitsGridConfig: GridConfig<VisitAttributes> = {
    rowIdField: '_id',
    sorting: {
      enabled: true,
      mode: 'local',
      multiColumn: true,
      defaultSort: []
    },
    pagination: {
      enabled: true,
      mode: 'local',
      pageSize: 50,
      pageSizeOptions: [25, 50, 100, 200],
      showPaginator: true
    },
    columnVisibility: {
      showToggleButton: false
    },
    columnFilters: {
      enabled: true,
      mode: 'local'
    },
    styling: {
      maxHeight: '65vh',
      density: 'compact',
      fontSize: '12px !important',
      cellPaddingX: '0px !important',
      cellPaddingY: '0px',
      stripedRows: false,
      rowHover: true,
      showBorders: true
    },
    settingsPanel: {
      enabled: true,
      position: 'right',
      enableColumnVisibility: true,
      enableDensity: false,
      enableExport: true,
      defaultDensity: 'comfortable'
    },
    emptyState: {
      message: 'No hay visitas registradas para este viaje',
      showIcon: true
    },
  };

  // Documentos
  displayedColumns: string[] = [
    "expandable",
    "circle",
    "shipTo",
    "document",
    "noSync",
    "toSync",
    "sync",
  ];

  displayedColumnsShip: string[] = [
    "expandable",
    "status",
    "statusERP",
    "type",
    "class",
    "serial",
    "loan",
    "price",
  ];

  displayedColumnsMaterial: string[] = [
    "material",
    "quantity",
    "loan",
    "price",
  ];

  clientMaterialsSummary: ClientMaterialSummary[] = [];
  groupedMaterialsWithCustomers: GroupedMaterialWithCustomers[] = [];
  totalItemsClientMaterials: number = 0;
  pageSizeClientMaterials: number = 100;
  pageIndexClientMaterials: number = 0;
  isLoadingClientMaterials: boolean = false;


  // Add to principal-screen.component.ts
  dataSourceWorkProgressMaterials = new MatTableDataSource([]);
  workProgressMaterialsSummary: WorkProgressMaterialItem[] = [];
  totalItemsWorkProgressMaterials: number = 0;
  pageIndexWorkProgressMaterials: number = 0;
  pageSizeWorkProgressMaterials: number = 100;


  public selectedShip;
  public selectedInner: GroupedPayment | null = null;
  public dataSourceMaterialDocuments: MatTableDataSource<any>;
  // Status document

  statusDocument: statusDocument = {
    countDocument: 0,
    notAllowedSync: 0, // los que no tienen la variable statusERP
    notSynchronization: 0,  // statusERP = OrderStatusERPEnum.ORDER_ERROR_ERP, OrderStatusERPEnum.ORDER_ERROR
    loadSynchronization: 0, // statusERP = OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE, OrderStatusERPEnum.ORDER_RECEIVED, OrderStatusERPEnum.ORDER_PENDING, OrderStatusERPEnum.ORDER_SEND
    synchronization: 0, // statusERP OrderStatusERPEnum.ORDER_CREATED
  };

  statusDocumentCharge: statusDocument = {
    countDocument: 0,
    notAllowedSync: 0, // los que no tienen la variable statusERP
    notSynchronization: 0,  // statusERP = OrderStatusERPEnum.ORDER_ERROR_ERP, OrderStatusERPEnum.ORDER_ERROR
    loadSynchronization: 0, // statusERP = OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE, OrderStatusERPEnum.ORDER_RECEIVED, OrderStatusERPEnum.ORDER_PENDING, OrderStatusERPEnum.ORDER_SEND
    synchronization: 0, // statusERP OrderStatusERPEnum.ORDER_CREATED
  };

  statusDocumentDelivery: statusDocumentDelivery = {
    countDocument: 0,
    notDelivered: 0,
    delivered: 0,
    loadDelivered: 0,
  };

  statusRoute: IStatusRoute = {
    visitNotValid: 0,
    visitValid: 0,
    countDocument: 0,
  };

  subs: Subscription[] = [];

  //empty document
  showButton: boolean = false;
  showButtonSpare: boolean = false;
  soldToList: any[] = [];
  selectedSoldTo: any = null;
  detail: any = {
    selectedUnit: null,
    baseQuantity: null,
    pararellQuantity: null
  };
  selectNew = signal<any>(null);

  windowOpen$: Observable<boolean>;

  documentTypesForClientsGroupedByMaterial: string[] = [DocumentTypeEnum.ENTREGA_SALIDA];

  //map
  isNew: boolean = true;
  monitorDocumentTypeEnum = MonitorDocumentTypeEnum

  //Purge
  tripStatus = TripStatus

  //Release
  // tripStatus = TripStatus

  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private readonly companyService: CompanyService,
    private ordersListService: OrdersListService,
    private readonly tripService: TripRouteService,
    private readonly userMasterService: UserMasterService,
    private readonly vehicleService: VechicleService,
    private readonly cdr: ChangeDetectorRef,
    private readonly documentTypeService: DocumentTypeService,
    private readonly paymentIntegratorService: OrderPaymentIntegratosServicesService,
    private readonly orederService: PrincipalScreenService,
    private readonly paymentService: PaymentOrderService,
    private readonly visitService: TripService,
    private salesDistributionService: SalesDistributionService,
    private readonly updateOrderService: UpdateOrderService,
    private activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private windowState: WindowStateService,
    private chargePartnerExport: ChargePartnerExport,
    private workCourseCustomerExport: WorkCourseCustomerExport,
    private readonly liquidationService: LiquidationService,
    private readonly pinnedTripsService: PinnedTripsService,
    private readonly expenseService: ExpenseService,
    private readonly _fuseNavigationService: FuseNavigationService,
    private readonly auditLogViewerService: AuditLogViewerService
  ) {
    this.windowOpen$ = this.windowState.isOpen$;
  }

  openRoutesByVehicleIdModal(): void {
    this.dialogRefRoutesByVehicleIdModal = this.dialog.open(this.viewRoutesByVehicleIdModal, {
      panelClass: "form-modal-routes",
      disableClose: true,
      maxWidth: '100%',
      width: '1100px',           // ancho del modal
      height: '280px'
    });
    this.dialogRefRoutesByVehicleIdModal.afterClosed().subscribe((result) => {
      result
    });
  }

  ngOnInit() {
    this.findAllTypeDocument();
    this.statusTrip();
    this.initializeChargeOrdersColumnDefs();
    this.initializeMaterialDetailsColumnDefs();
    this.setupNavigationListener();
  }

  /**
   * Sets up listener for navigation state changes to conditionally apply CSS classes
   */
  private setupNavigationListener(): void {
    const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>('mainNavigation');

    if (navigation) {
      // Set initial state
      this.isNavOpened = navigation.opened;

      // Subscribe to changes
      navigation.openedChanged
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((opened: boolean) => {
          this.isNavOpened = opened;
          this.cdr.detectChanges();
        });
    }
  }

  onVehicleSelected(vehicleId: string) {
    this.parameterIdForVehicles = [];
    this.parameterIdForVehicles.push(vehicleId);
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.length = this.totalItems;
    }

    this.subs.push(
      this.activatedRoute.queryParams.subscribe((params) => {
        if (params["tripId"]) {
          this.pageIndex = this.paginator.pageIndex + 1;
          this.fetchAllWithCount(
            this.pageSize,
            this.pageIndex,
            null,
            null,
            null,
            Number(params["tripId"])
          );
        } else {
          const date = new Date();
          this.pageIndex = this.paginator.pageIndex + 1;
          this.fetchAllWithCount(
            this.pageSize,
            this.pageIndex,
            null,
            date,
            null,
            null
          );
        }
      })
    );
  }
  // Función para verificar si un nodo tiene hijos
  hasChild = (_: number, node: TripFlatNode) => {
    return (node.isStatusGroup || node.isFunctionGroup) &&
      node.children && node.children.length > 0;
  };
  // Función para obtener el nivel de un nodo
  getLevel = (node: TripFlatNode) => node.levelTree;



  ngOnChanges(changes: SimpleChanges) {
    // Procesar datos cuando cambia dataSource O companyList
    if (changes["dataSource"] || changes["companyList"]) {
      // Solo procesar si AMBOS están disponibles (evita race condition)
      if (this.dataSource && this.companyList && this.companyList.length > 0) {
        this.cdr.detectChanges();
        this.totalItems = this.dataSource?.pageInfo?.[0]?.total ?? 0;
        const processedData = this.dataSource?.data?.map((route) => {
          const company = this.getCompanyItem(route)
          return {
            ...route,
            statusTripId: this.statusIdTrip(route.statusTripId),
            isAvailableTripPurge: company?.isAvailableTripPurge || false
          }
        }) ?? [];
        this.dataSourceRoute = processedData;
        this.routeDataArray = processedData;
        // modo
        if (this.modeTreeMonitor === 'statusTrip') {
          this.dataSourceRouteTree.data = this.buildTreeByStatus(this.routeDataArray);
        } else if (this.modeTreeMonitor === 'functionTrip') {
          this.dataSourceRouteTree.data = this.buildTreeByFunction(this.routeDataArray);
        }
      }
    }
    // detectar cambios en modeTreeMonitor
    if (changes["modeTreeMonitor"]) {
      if (this.routeDataArray?.length) {
        if (this.modeTreeMonitor === 'statusTrip') {
          this.dataSourceRouteTree.data = this.buildTreeByStatus(this.routeDataArray);
        } else if (this.modeTreeMonitor === 'functionTrip') {
          this.dataSourceRouteTree.data = this.buildTreeByFunction(this.routeDataArray);
        }
      }
    }
  }

  /**
   * Lifecycle hook called when component is destroyed
   * Unsubscribes from all active subscriptions to prevent memory leaks
   */
  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
    this.subs = [];

    // Clean up navigation state subscription
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
  verifidUnified(item) {
    const deliveryUnified = item.filter((doc) => doc?.isUnified == true).length;
    return deliveryUnified;
  }

  private getCompanyItem(item): CompanyAttributes {
    return this.companyList.find((c) => c.id === item.company?.id);
  }

  private fetchDocumentClass(documentType: string) {
    let dataToFilter = {
      type: documentType,
    };
    this.ordersListService
      .fetchDocumentClasses(dataToFilter)
      .subscribe((res) => {
        this.documentClassesList = res.data;
      });
  }

  private async fetchDocumentClassIn(documentType: string): Promise<void> {
    const dataToFilter = {
      type: documentType,
    };
    try {
      const res = await firstValueFrom(
        this.ordersListService.fetchDocumentClasses(dataToFilter)
      );
      this.documentClassesList = res.data;
    } catch (err) {
      this.snackBar.open(err.error.message || "Error al obtener clases de documentos", "Cerrar", { duration: 5000 });
    }
  }

  private statusIdTrip(status: number): {
    id: number;
    color: string;
    info: string;
  } {
    switch (status) {
      case StatusEnum.TRIP_CREATED:
        return {
          id: StatusEnum.TRIP_CREATED,
          color: "bg-yellow-500",
          info: "Abierto",
        };
      case StatusEnum.TRIP_READY_TO_START:
        return {
          id: StatusEnum.TRIP_READY_TO_START,
          color: "bg-blue-500",
          info: "Cargando",
        };
      case StatusEnum.TRIP_IN_PROCESS:
        return {
          id: StatusEnum.TRIP_IN_PROCESS,
          color: "bg-green-600",
          info: "En proceso",
        };
      case StatusEnum.TRIP_CLOSED:
        return {
          id: StatusEnum.TRIP_CLOSED,
          color: "bg-gray-500",
          info: "Cerrado",
        };
      case StatusEnum.TRIP_IN_LIQUIDATION:
        return {
          id: StatusEnum.TRIP_IN_LIQUIDATION,
          color: "bg-purple-500",
          info: "Liquidando",
        };
      case StatusEnum.TRIP_LIQUIDATION_DOC_CREATED:
        return {
          id: StatusEnum.TRIP_LIQUIDATION_DOC_CREATED,
          color: "bg-purple-600",
          info: "Doc. Liquidación Creado",
        };
      case StatusEnum.TRIP_LIQUIDATION_DOC_APPROVED:
        return {
          id: StatusEnum.TRIP_LIQUIDATION_DOC_APPROVED,
          color: "bg-purple-700",
          info: "Doc. Liquidación Aprobado",
        };
      case StatusEnum.TRIP_FINALIZED:
        return {
          id: StatusEnum.TRIP_FINALIZED,
          color: "bg-green-700",
          info: "Finalizado",
        };
      default:
        return {
          id: 0,
          color: "bg-gray-300",
          info: "Estado desconocido",
        };
    }
  }
  isGroupNode(node: TripNode | TripFlatNode): boolean {
    return !!node.auxUniqueStatus ||
      !!node.auxUniqueFunction ||
      node.id?.toString().startsWith('status-') ||
      node.id?.toString().startsWith('function-') ||
      !node.subRoute;
  }
  getGroupName(node: TripNode | TripFlatNode): string {
    // Para modo estado
    if (this.modeTreeMonitor === 'statusTrip' && node.auxUniqueStatus) {
      return TRIP_STATUS_CONFIG?.find(config => config.value === node.auxUniqueStatus.id)?.shortLabel?.toUpperCase() ?? 'DESCONOCIDO';
    }
    // Para modo función
    if (this.modeTreeMonitor === 'functionTrip' && node.auxUniqueFunction) {
      return node.auxUniqueFunction.name;
    }
    return '-';
  }
  getGroupColor(node: TripNode | TripFlatNode): string {
    if (node.auxUniqueStatus) {
      return node.auxUniqueStatus.color;
    }
    if (node.auxUniqueFunction) {
      return 'bg-blue-500';
    }
    return 'bg-gray-300';
  }

  private transformData(trip: TripAttributes | any) {
    const routes = trip.map((route) => {
      const company = this.getCompanyItem(route)
      this.UMPActive = company.UMPActive;
      // Update Observable for reactive UMPActive
      this.UMPActiveSubject$.next(this.UMPActive);
      const stops = this.calculateVisitValid(route.visits);

      const loan: any = this.calculateTotalWeight(route.orders);
      this.loanUnit = loan.unit;
      this.currency = company?.currencyBase?.code;
      const quantity = route?.orders?.length + route?.payments?.length;
      const counts: { [key: number]: number } = {};
      const routeOrders = !!route?.orders?.length ? route.orders : [];
      const filteredData = routeOrders.filter(
        (item) =>
          item.type.code !== DocumentTypeEnum.DOCUMENTO_DE_CARGA &&
          item.type.code !== DocumentTypeEnum.ENTREGA_SALIDA &&
          item.type.code !== DocumentTypeEnum.DOCUMENTO_DE_TRANSPORTE &&
          item.type.code !== DocumentTypeEnum.ENTREGA_ENTRADA
      );
      const filteredDataPartner = routeOrders.filter((item) => {
        return (
          item.type.code === DocumentTypeEnum.FACTURA ||
          (item.type.code === DocumentTypeEnum.ENTREGA_SALIDA && item.class.hasExternalInvoice) ||
          (item.type.code !== DocumentTypeEnum.DOCUMENTO_DE_CARGA &&
            item.type.code !== DocumentTypeEnum.ENTREGA_SALIDA &&
            item.type.code !== DocumentTypeEnum.DOCUMENTO_DE_TRANSPORTE &&
            item.type.code !== DocumentTypeEnum.ENTREGA_ENTRADA)
        );
      });

      const filteredCharge = routeOrders.filter(
        (item) => item.type.code === DocumentTypeEnum.DOCUMENTO_DE_CARGA
      );

      const filteredDelivery = routeOrders.filter(
        (item) => item.type.code === DocumentTypeEnum.ENTREGA_SALIDA || item.type.code === DocumentTypeEnum.DOCUMENTO_DE_TRANSPORTE
      );

      const statusDocument: statusDocument = this.calculateStatus(filteredData);

      const statusDocumentCharge: statusDocument =
        this.calculateStatus(filteredCharge);

      const statusDocumentDelivery: statusDocument =
        this.calculateStatus(filteredDelivery);

      const chargeGroups = this.groupCharges([
        ...(filteredCharge && filteredCharge.length > 0 ? filteredCharge : []),
      ]);

      const deliveryGroups = this.groupCharges([
        ...(filteredDelivery && filteredDelivery.length > 0
          ? filteredDelivery
          : []),
      ]);

      // const groupDocument = this.groupByDocument([
      //   ...(filteredData && filteredData.length > 0 ? filteredData : []),
      // ]);

      const paymentDocument = this.groupByDocumentPayment([
        ...(route.payments && route.payments.length > 0 ? route.payments : []),
      ]);

      // const combinedDocuments = [...groupDocument, ...paymentDocument];
      return {
        _id: route._id,
        id: route.id,
        route: {
          code: route?.subRoute?.externalKeys?.code,
          name: route.subRoute.name,
        },
        description: route?.description,
        loadDateTime: route?.loadDateTime,
        subRouteId: route?.subRoute,
        vehicleId: route?.vehicle,
        masterUserId: route?.user,
        statusTripCode: route?.statusTripId,
        stops: stops,
        randomNumber: counts,
        vehicle: route.vehicle,
        ride: route.vehicle?.businessPartner,
        dateHourEnd: {
          real: route.dateHourEnd,
          teoric: route.dateHourEndTeoric,
        },
        dateHourStart: {
          real: route.dateHourStart,
          teoric: route.dateHourStartTeoric,
        },
        user: route.user.user_login.username,
        userModel: route.user,
        responsable: route?.orders?.map((a) => a.responsibleBusinessPartner)[0],
        loan: loan,
        statusTripId: this.statusIdTrip(route.statusTripId),
        documents: this.groupOrders([
          ...(filteredDataPartner && filteredDataPartner.length > 0
            ? filteredDataPartner
            : []),
        ]),
        chargeGroups,
        deliveryGroups,
        quantity: quantity,
        visits: route.visits,
        statusDocument,
        statusDocumentCharge,
        statusDocumentDelivery,
        isAvailableTripPurge: company?.isAvailableTripPurge || false,
        // combinedDocuments,
      };
    });

    //this.routes = routes;
    return routes;
  }

  processCombinedDocuments(originalData: any[]) {
    // 1. Separar documentos normales de pagos
    const documents = originalData.filter((doc) => doc.typeCode !== DocumentTypeEnum.DOCUMENTO_DE_PAGO);
    const payments =
      originalData.find((doc) => doc.typeCode === DocumentTypeEnum.DOCUMENTO_DE_PAGO)?.items || [];

    // 2. Procesar pagos FACTURA_AVE
    const avePayments = payments?.filter((p) => p.codeReason === PaymentReasonEnum.FACTURA_AVE);
    const normalPayments = payments.filter(
      (p) => p.codeReason !== PaymentReasonEnum.FACTURA_AVE
    );

    // 3. Agregar pagos FACTURA_AVE a sus documentos correspondientes
    documents.forEach((doc) => {
      if (doc.typeCode === DocumentTypeEnum.FACTURA) {
        doc.items.forEach((item) => {
          item.relatedPayments = avePayments.filter(
            (p) => p.document === item.serial
          );
        });
      }
    });

    // 4. Crear nuevo array combinado
    const result = [...documents];
    // 5. Agregar pagos normales como DocumentTypeEnum.DOCUMENTO_DE_PAGO solo si existen
    if (normalPayments.length > 0) {
      result.push({
        typeCode: DocumentTypeEnum.DOCUMENTO_DE_PAGO,
        items: normalPayments,
        name: "DOCUMENTO DE PAGO",
      });
    }
    return result;
  }

  getRelatedPayments(document: any): any[] {
    if (!document?.relatedPaymentsCache?.data || !document?.items?.data)
      return [];

    return document.relatedPaymentsCache.data.filter(
      (payment) =>
        payment.codeReason == PaymentReasonEnum.FACTURA_AVE &&
        document.items.data.some((item) => item.serial === payment.document)
    );
  }

  getValidPayments(document: any): any[] {
    if (!document?.relatedPaymentsCache?.data || !document?.items?.data) {
      return [];
    }

    return document.relatedPaymentsCache.data.filter(
      (payment) =>
        payment.codeReason === PaymentReasonEnum.FACTURA_AVE &&
        document.items.data.some(
          (item) => item.serial === payment.document && item.statusId !== StatusEnum.INACTIVE // Solo facturas no anuladas
        )
    );
  }


  private groupCharges(data: any[]) {
    const groupedDataPartner = new Map<string, any>(); // Agrupar por `shipTo.name`
    const groupedDataMaterial = new Map<string, any>(); // Agrupar por `material.name`
    var deliveryFinish = 0;
    /*
        const filterData = data
          .filter((item) => item.type.code === DocumentTypeEnum.DOCUMENTO_DE_CARGA)
          .map((item) => ({ ...item })); */
    data.forEach((item) => {
      // Entregado

      item.statusId === StatusEnum.ORDER_DELIVERED && deliveryFinish++;

      // Clave para agrupar por `shipTo.name`
      const keyPartner = item.shipTo.name;
      const loan = this.calculateTotalWeghtDetail(item);
      const subTotal = item.subTotal;
      const nroDocuments = item.detail.length;

      //  Agrupar por `shipTo`
      if (!groupedDataPartner.has(keyPartner)) {
        groupedDataPartner.set(keyPartner, {
          shipTo: item.shipTo,
          loan: { unit: loan.unit, value: 0 },
          nroDocuments: 0,
          total: 0,
          items: [],
        });
      }

      // Actualizar valores dentro del grupo `shipTo`
      const groupPartner = groupedDataPartner.get(keyPartner)!;
      groupPartner.loan.value += loan.value;
      groupPartner.nroDocuments += 1;
      groupPartner.total += subTotal;
      groupPartner.items.push({ ...item, loan, nroDocuments });

      // Agrupar por `material.name`
      item.detail.forEach((detail) => {
        const keyMaterial = detail.material.name;

        if (!groupedDataMaterial.has(keyMaterial)) {
          groupedDataMaterial.set(keyMaterial, {
            name: keyMaterial,
            price: detail.unitPrice,
            code: detail.material.code,
            baseUnitOfMeasure: detail.baseUnitOfMeasure,
            pararellUnitOfMeasure: detail.pararellUnitOfMeasure,
            baseQuantity: 0,
            pararellQuantity: 0,
            soldQuantity: 0,
            stockConfirmedERP: detail.stockConfirmedERP ?? null,
            orders: new Set(),
          });
        }

        // Acumular cantidades de material correctamente
        const groupMaterial = groupedDataMaterial.get(keyMaterial)!;
        groupMaterial.baseQuantity += detail.baseQuantity ?? 0;
        groupMaterial.pararellQuantity += detail.pararellQuantity ?? 0;
        groupMaterial.soldQuantity += detail.soldQuantity ?? 0;

        // Agregar `shipTo` dentro de `orders` sin duplicados
        groupMaterial.orders.add({
          shipTo: item.shipTo,
          soldTo: item.soldTo,
          quantities: {
            requestedBase: detail.baseQuantity,
            requestedPararell: detail.pararellQuantity,
            confirmed: detail.soldQuantity,
          },
          serial: item.serial,
        });
      });
    });

    // Convertir `Map` a array de resultados asegurando que incluimos todas las propiedades
    return {
      partners: Array.from(groupedDataPartner.values()), // Agrupados por `shipTo.name`
      materials: Array.from(groupedDataMaterial.values()).map((group) => ({
        name: group.name,
        price: group.price,
        code: group.code,
        baseUnitOfMeasure: group.baseUnitOfMeasure,
        pararellUnitOfMeasure: group.pararellUnitOfMeasure,
        baseQuantity: group.baseQuantity, //  Ahora correctamente acumulado
        pararellQuantity: group.pararellQuantity, // Ahora correctamente acumulado
        soldQuantity: group.soldQuantity, //  Ahora correctamente acumulado
        stockConfirmedERP: group.stockConfirmedERP,
        orders: Array.from(group.orders), // Convertir `Set` en array sin duplicados
      })),
      loans: data,
      deliveryFinish,
    };
  }

  private groupOrders(data): any {
    let groupedDataSource = data.reduce((result, item) => {
      const key = `${item.shipTo.externalKeys.code}|${item.trip.id}|`;

      if (!result[key]) {
        result[key] = {
          identifier: key,
          id: item.id || item.code,
          shipTo: item.shipTo,
          documents: 0,
          ordersByTypeAndSerial: [],
          address: item.address,
          deliveryDateTime: item.deliveryDateTime,
          currency: item.currency,
          serial: item.serial,
        };
      }

      const documentTypeKey = item.type.code;
      const serialKey = item.serial;

      let typeAndSerialGroup = result[key].ordersByTypeAndSerial.find(
        (group) =>
          group.type.code === documentTypeKey && group.serial === serialKey
      );

      if (!typeAndSerialGroup) {
        typeAndSerialGroup = {
          type: item.type,
          class: item.class,
          serial: item.serial,
          loan: 0,
          total: 0,
          weightUnitOfMeasureCode: "LB",
          items: [],
          statusERP: item.statusERP,
          statusId: item.statusId,
        };
        result[key].ordersByTypeAndSerial.push(typeAndSerialGroup);
      }

      typeAndSerialGroup.items.push(item.detail);

      const company = this.companyList.find(
        (company) => company.id === item.company.id
      );

      const loadCalculationMode =
        company && company.loadCalculationMode
          ? company.loadCalculationMode
          : LoadCalculationModeEnum.BY_DIMENSIONS;

      const enrichedDetail = item.detail.map((detailItem) => {
        let loan = 0;
        let price = 0;
        let weightUnitOfMeasureCode = "LB";

        this.UMPActive = company.UMPActive;
        this.totalUnit = company?.currencyBase?.code ?? "";

        price = detailItem.originalUnitPrice * detailItem.soldQuantity;

        if (loadCalculationMode === LoadCalculationModeEnum.BY_DIMENSIONS) {
          if (detailItem.material && detailItem.material.dimensions) {
            const grossWeight = detailItem.material.dimensions.grossWeight || 0;
            const baseQuantity = detailItem.material.baseQuantity || 0;
            weightUnitOfMeasureCode =
              detailItem.material.dimensions.weightUnitOfMeasureCode || "LB";
            loan = grossWeight * baseQuantity;
          }
        } else if (
          loadCalculationMode === LoadCalculationModeEnum.BY_BASE_QUANTITY
        ) {
          if (detailItem) {
            const baseQuantity = detailItem.baseQuantity || 0;
            weightUnitOfMeasureCode =
              detailItem.baseUnitOfMeasure?.code || "LB";
            loan = baseQuantity;
          }
        }

        return {
          ...detailItem,
          type: item.type.name,
          price: price,
          loan: loan,
          statusERP: item.statusERP,
          statusId: item.statusId,
          weightUnitOfMeasureCode: weightUnitOfMeasureCode,
        };
      });
      typeAndSerialGroup.items.push(...enrichedDetail);

      const groupLoan = enrichedDetail.reduce(
        (sum, detailItem) => sum + detailItem.loan,
        0
      );
      typeAndSerialGroup.loan += groupLoan;

      const groupTotal = enrichedDetail.reduce(
        (sum, detailItem) => sum + detailItem.price,
        0
      );
      typeAndSerialGroup.total += groupTotal;

      result[key].subTotal += groupTotal;
      result[key].statusDocument = this.calculateStatus(
        result[key].ordersByTypeAndSerial
      );
      // Actualizamos la unidad de medida del peso
      // result[key].weightUnitOfMeasureCode = weightUnitOfMeasureCode;

      // Si el item tiene tipo, incrementamos el contador de documentos
      if (item.type) {
        result[key].documents += 1;
      }
      // if (item.id) {
      //   result[key].detail.push({
      //     material: { name: '' },
      //     originalUnitPrice: 0,
      //     loan: 0.00,
      //     type: 'VISITA',
      //     serial: item?.serials || 'Estableci'
      //   });
      // }

      // // Si el item tiene tipo, incrementar el contador de documentos
      // if (item.type) {
      //   result[key].documents += 1;
      // }

      result[key].subTotal += item.subTotal || 0;

      return result;
    }, {});

    let dataSource = Object.values(groupedDataSource);
    return dataSource;
  }

  //construccion arbol function 
  private buildTreeByFunction(data: TripAttributes[]): TripNode[] {
    const functionGroups = new Map<string, TripNode>();
    for (const trip of data ?? []) {
      if (trip.subRoute?.function) {
        const functionName = trip.subRoute.function.name; // "ENTREGA" o "PREVENTA"
        const functionInfo = {
          id: trip.subRoute.function._id.toString(),
          name: functionName,
          model: trip.subRoute.function.code
        };
        if (!functionGroups.has(functionName)) {
          functionGroups.set(functionName, {
            ...trip,
            id: `function-${functionName}`,
            auxUniqueFunction: functionInfo,
            children: [],
            isFunctionGroup: true,
          });
        }
        functionGroups.get(functionName)!.children.push({
          ...trip,
          id: trip.id ?? `child-${trip.subRoute?.function?._id ?? Math.random()}`,
          auxUniqueFunction: functionInfo,
          isFunctionGroup: false,
        });
      }
    }
    return Array.from(functionGroups.values());;

    // Sort children in each group to put pinned trips first
    const result = Array.from(functionGroups.values());
    result.forEach(group => {
      if (group.children && group.children.length > 1) {
        group.children.sort((a, b) => {
          const aPinned = this.pinnedTripIds.has(a.id as number);
          const bPinned = this.pinnedTripIds.has(b.id as number);

          // Pinned trips go first
          if (aPinned && !bPinned) return -1;
          if (!aPinned && bPinned) return 1;

          // Keep original order for the rest
          return 0;
        });
      }
    });

    return result;
  }

  private buildTreeByStatus(data: any[]): TripNode[] {
    const statusGroups = new Map<number, TripNode>();
    // Agrupar viajes por estado
    for (const trip of data ?? []) {
      if (trip.statusTripId) {
        // trip.statusTripId  viene como { id, color, info } 
        const statusInfo = trip.statusTripId;
        const statusId = statusInfo.id;
        if (!statusGroups.has(statusId)) {
          // Crear nodo padre para el estado
          statusGroups.set(statusId, {
            ...trip,
            id: `status-${statusId}`,
            auxUniqueStatus: statusInfo,
            children: [],
            isStatusGroup: true,
          });
        }
        // si id esválido
        const childTrip: TripNode = {
          ...trip,
          id: trip.id ?? trip._id?.toString() ?? `trip-${Math.random()}`,
          auxUniqueStatus: statusInfo,
          isStatusGroup: false,
        };
        statusGroups.get(statusId)!.children!.push(childTrip);
      }
    }

    // Sort children in each group to put pinned trips first
    const result = Array.from(statusGroups.values());
    result.forEach(group => {
      if (group.children && group.children.length > 1) {
        group.children.sort((a, b) => {
          const aPinned = this.pinnedTripIds.has(a.id as number);
          const bPinned = this.pinnedTripIds.has(b.id as number);

          // Pinned trips go first
          if (aPinned && !bPinned) return -1;
          if (!aPinned && bPinned) return 1;

          // Keep original order for the rest
          return 0;
        });
      }
    });

    return result;
  }
  // private groupByDocument(data) {
  //   const groupedData = new Map<string, any[]>();

  //   data.forEach((item) => {
  //     const key = item.type.code; // Obtener el código de tipo

  //     if (!groupedData.has(key)) {
  //       groupedData.set(key, []); // Inicializar si no existe
  //     }

  //     groupedData.get(key)?.push({ ...item }); // Agregar copia del item al grupo
  //   });

  //   // Convertimos el Map a un array de objetos
  //   return Array.from(groupedData.entries()).map(([code, items]) => {
  //     const typeDocument: any = this.documentTypeList.filter(
  //       (item) => item.code === code
  //     );
  //     return {
  //       typeCode: code,
  //       items,
  //       name: typeDocument[0].name,
  //     };
  //   });
  // }

  private async fechtDocumentTypes() {
    const result = await Promise.all(
      this.documentTypeList.map(async (type) => {
        const items = await this.loadDataDocumentGeneral(type.code);
        if (items?.[0]?.data.length > 0) {
          return {
            typeCode: type.code,
            items: items[0],
            name: type.name,
            counts: items.counts,
          };
        }
        return null;
      })
    );

    return result.filter((doc) => doc !== null);
  }

  getCountByStatus(counts: any[], status: string): number {
    if (!counts) return 0;
    const item = counts.find((c) => c.syncStatus === status);
    return item ? item.count : 0;
  }

  getTotalCount(counts: any[]): number {
    if (!counts) return 0;
    return counts.reduce((total, item) => total + item.count, 0);
  }

  private groupByDocumentPayment(data) {
    const groupedData = new Map<string, any[]>();

    data.forEach((item) => {
      const key = item.document_type.code; // Obtener el código de tipo

      if (!groupedData.has(key)) {
        groupedData.set(key, []); // Inicializar si no existe
      }

      groupedData.get(key)?.push({ ...item }); // Agregar copia del item al grupo
    });

    // Convertimos el Map a un array de objetos
    return Array.from(groupedData.entries()).map(([code, items]) => {
      const typeDocument: any = this.documentTypeList.filter(
        (item) => item.code === code
      );
      return {
        typeCode: code,
        items,
        name: typeDocument[0].name,
      };
    });
  }

  private groupMaterialCharge(data: any[]) {
    const materialsCharge = data.filter((item) => item.type.code === DocumentTypeEnum.DOCUMENTO_DE_CARGA);
  }

  // Calculo para las metricas generales de documentos
  private calculateStatus(documents: any[]): statusDocument {
    var countDocument = 0;
    var notAllowedSync = 0;
    var notSynchronization = 0;
    var loadSynchronization = 0;
    var synchronization = 0;
    documents.forEach((doc) => {
      countDocument++;
      if (doc.statusERP === undefined) {
        notAllowedSync++;
      } else if ([OrderStatusERPEnum.ORDER_ERROR_ERP, OrderStatusERPEnum.ORDER_ERROR].includes(doc.statusERP)) {
        notSynchronization++;
      } else if ([OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE, OrderStatusERPEnum.ORDER_RECEIVED, OrderStatusERPEnum.ORDER_PENDING, OrderStatusERPEnum.ORDER_SEND].includes(doc.statusERP)) {
        loadSynchronization++;
      } else if (doc.statusERP === OrderStatusERPEnum.ORDER_CREATED) {
        synchronization++;
      }
    });

    return {
      countDocument,
      notAllowedSync,
      notSynchronization,
      loadSynchronization,
      synchronization,
    };
  }

  private groupBusinnesPartner(orders) {
    const groupedOrders = orders?.reduce(
      (acc, order) => {
        const key = order.shipTo?.name;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(order);
        return acc;
      },
      {} as Record<string, OrderAttributes[]>
    );

    return Object.values(groupedOrders); // Devuelve una lista de arrays
  }

  private calculateTotalWeghtDetail(ordenPrincipal: any) {
    // Verificamos si existe 'orders' en el objeto principal
    const orders = ordenPrincipal?.orders ?? [];
    let totalWeight = 0;
    let weightUnit = "LB"; // Unidad por defecto

    // Recorremos cada order secundario
    orders.forEach((order: any) => {
      if (!order.detail) return; // Si no hay detail, saltamos

      const company = this.companyList.find((c) => c.id === order.company?.id);
      const loadCalculationMode = company?.loadCalculationMode
        ? company.loadCalculationMode
        : LoadCalculationModeEnum.BY_DIMENSIONS; // Modo por defecto

      // Calculamos el peso para cada detail en este order secundario
      const orderWeight = order.detail.reduce(
        (acc: number, detailItem: any) => {
          if (loadCalculationMode === LoadCalculationModeEnum.BY_DIMENSIONS) {
            if (detailItem.material?.dimensions) {
              const grossWeight =
                detailItem.material.dimensions.grossWeight || 0;
              const baseQuantity = detailItem.baseQuantity || 0;
              weightUnit =
                detailItem.material.dimensions.weightUnitOfMeasureCode ||
                weightUnit;
              return acc + grossWeight * baseQuantity;
            }
          } else if (
            loadCalculationMode === LoadCalculationModeEnum.BY_BASE_QUANTITY
          ) {
            const baseQuantity = detailItem.baseQuantity || 0;
            weightUnit = detailItem.baseUnitOfMeasure?.code || weightUnit;
            return acc + baseQuantity;
          }
          return acc;
        },
        0
      );

      totalWeight += orderWeight;
    });

    return {
      value: totalWeight,
      unit: weightUnit, // Retornamos la última unidad encontrada (o "LB" por defecto)
    };
  }
  private calculateVisits(orders: any, visits: any): number {
    return orders?.reduce((total, item) => {
      return (
        total +
        (visits?.filter((route) => route.serials === item.serial)?.length || 0)
      );
    }, 0);
  }

  private calculateTotalWeight(orders): object {
    let totalWeight = 0;
    let deliveredWeight = 0;
    let weightUnit = "LB";

    const ordersToUse = orders || [];

    ordersToUse.forEach((order) => {
      const company = this.companyList.find(
        (company) => company.id === order.company.id
      );
      if (company) {
        const loadCalculationMode =
          company && company.loadCalculationMode
            ? company.loadCalculationMode
            : LoadCalculationModeEnum.BY_DIMENSIONS;
        order.detail.forEach((detailItem) => {
          if (loadCalculationMode === LoadCalculationModeEnum.BY_DIMENSIONS) {
            if (detailItem.material && detailItem.material.dimensions) {
              // Si tiene dimensiones, hacemos el cálculo por dimensiones
              const grossWeight =
                detailItem.material.dimensions.grossWeight || 0;
              const baseQuantity = detailItem.baseQuantity || 0;
              const weightUnitFromDimensions =
                detailItem.material.dimensions.weightUnitOfMeasureCode || "LB";
              weightUnit = weightUnitFromDimensions;

              const weightedGrossWeight = grossWeight * baseQuantity;
              totalWeight += weightedGrossWeight;
              if (
                deliveredWeight === 0 &&
                (order.type.code === DocumentTypeEnum.FACTURA || order.type.code === DocumentTypeEnum.ENTREGA_SALIDA)
              ) {
                deliveredWeight = weightedGrossWeight;
              }
            }
          } else if (
            loadCalculationMode === LoadCalculationModeEnum.BY_BASE_QUANTITY
          ) {
            if (detailItem.material) {
              const baseQuantity = detailItem.baseQuantity || 0;
              const weightUnitFromBaseQuantity =
                detailItem.baseUnitOfMeasure?.code || "LB";
              weightUnit = weightUnitFromBaseQuantity;

              const weightedGrossWeight = baseQuantity;
              totalWeight += weightedGrossWeight;
              if (
                deliveredWeight === 0 &&
                (order.type.code === DocumentTypeEnum.FACTURA || order.type.code === DocumentTypeEnum.ENTREGA_SALIDA)
              ) {
                deliveredWeight = weightedGrossWeight;
              }
            }
          }
        });
      }
    });

    return {
      value: totalWeight,
      unit: weightUnit,
    };
  }

  public onPageChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;

    this.fetchAllWithCount(this.pageSize, this.pageIndex, null);
  }
  statusOrders = {
    punctual: 0,
    calcel: 0,
    delivery: 0,
    delay: 0,
  };
  private statusTravel(status) {
    switch (true) {
      case [StatusEnum.ORDER_IN_PROGRESS, StatusEnum.ORDER_APPROVED, StatusEnum.ACTIVE].includes(status):
        this.statusOrders.punctual++;
        return { color: "bg-primary", info: "Puntuales" };
      case status === StatusEnum.ORDER_REJECTED:
        this.statusOrders.calcel++;
        return { color: "bg-red-500", info: "Cancelada" };
      case status === StatusEnum.ORDER_DELIVERED:
        this.statusOrders.delivery++;
        return { color: "bg-green-500", info: "Entregada" };
      default:
        this.statusOrders.delay++;
        return { color: "bg-yellow-500", info: "Demoras" };
    }
  }

  /* 
  
  Puntuales:  
  Demoras: 
  Entrega: 9
  Canceladas: 11, 0,  
  */

  private formatDataModal(data, unit) {
    const visits = [];
    this.statusOrders = {
      punctual: 0,
      calcel: 0,
      delivery: 0,
      delay: 0,
    };
    const documents = (data?.orders || [])
      .map((document) => {
        if (document.type.code === DocumentTypeEnum.PEDIDO) {
          const items: any = [];
          const result = document.detail.reduce(
            (acc, item) => {
              acc.loan += item.baseQuantity ?? 0;
              acc.total += item.subTotal ?? 0;

              item.serial = document.serial;
              item.type = document.type;

              return acc;
            },

            { loan: 0, total: 0 }
          );

          const visit = data.visits.filter((item) => {
            // Asegurarse de que `serials` es una cadena y dividirla en un array
            const serials = item.serials
              .split(", ")
              .map((serial) => serial.trim());

            // Verificar si algún serial coincide con algún valor en document.serial
            const match = serials.some((serial) =>
              document.serial.includes(serial)
            );

            return match; // Filtrar por los elementos que tengan alguna coincidencia
          });

          visits.push(...visit);
          const statusDelivery = this.statusTravel(document?.statusId);
          return {
            _id: document._id,
            address: document?.address,
            deliveryDateTime: document?.deliveryDateTime,
            statusERP: document?.statusERP,
            statusId: document?.statusId,
            materials: document?.detail,
            shipTo: document?.shipTo,
            serial: document?.serial,
            statusDelivery: statusDelivery,
            code: document?.code,
            loan: {
              value: result.loan,
              unit: unit,
            },
            total: result.total,
            items: document?.detail,
          };
        }
        return null;
      })
      .filter((item) => item !== null && item !== undefined);

    return {
      ...data,
      documents: documents,
      size: data?.orders?.length,
      statusDelivery: this.statusOrders,
      visits,
    };
  }

  public openModalMonitor(itemSelect, i) {
    const data = this.formatDataModal(
      this.dataSource.data[i],
      itemSelect.totalWeight.unit
    );

    const dialogRef = this.dialog.open(ModalMonitorRealtimeComponent, {
      panelClass: "form-modal",
      disableClose: true,
      data,
    });

    dialogRef.afterOpened().subscribe(() => { });
  }

  private concatOrderDocument(visits, orders) {
    return visits.map((visit) => {
      const ordersVisit = orders.filter((order) =>
        visit.serials.split(", ").includes(order.serial)
      );

      return {
        ...visit,
        orders: ordersVisit,
      };
    });
  }

  // Tabla principal
  public toggleDetails(dataSelect: any) {
    if (this.selectedMR && this.selectedMR._id === dataSelect._id) {
      this.selectedMR = null;
      return;
    }

    this.selectedMR = dataSelect;

    // Update UMPActive from selected trip's company
    const company = this.getCompanyItem(dataSelect);
    if (company) {
      this.UMPActive = company.UMPActive;
      this.UMPActiveSubject$.next(this.UMPActive);
    }

    this.userRequestedMap = false;

    // Documentos de Carga
    this.loadDataOrderLoan(dataSelect);

    // Entregas
    this.loadDataDeliveryLoan(dataSelect);

    this.loadDataTransport(dataSelect);

    this.loadDataDocument(dataSelect);

    this.loadDataDocumentClient(dataSelect);

    this.loadDataVisit(dataSelect);

    this.loadPaymentsGeneral(dataSelect);

    this.loadExpenseDocuments(dataSelect);

    // this.dataSourceDocumentsDetails = new MatTableDataSource([
    //   {
    //     nroOrder: this.dataSourceItemsDocuments.data.length,
    //     nroView: 3,
    //     otherDocuments: 2,
    //   },
    // ]);
    this.cdr.detectChanges();
  }

  onPageChangeOrderLoan(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;
    this.pageSizeLoan = event.pageSize;
    this.loadDataOrderLoan(this.selectedMR);
  }

  //Aqui se carga la data de los documentos de carga  y
  //tambien aqui se carga los resumen por material
  async loadDataOrderLoan(dataSelect) {
    try {
      const sortField = "createdAt";
      const tripId = dataSelect.id;
      const document = [DocumentTypeEnum.DOCUMENTO_DE_CARGA];
      const statusIds = [1, 9, 10, 11];

      const data = await this.findAllWithCountForDocument(
        this.pageSizeLoan,
        this.currentPage,
        sortField,
        tripId,
        document,
        statusIds
      );

      //DocumentTypeEnum.DOCUMENTO_DE_CARGA
      // Se flitra por statusId: StatusEnum.ACTIVE,StatusEnum.ORDER_DELIVERED,StatusEnum.ORDER_PARTIAL_DELIVERED,StatusEnum.ORDER_DELIVERY_REJECTED
      this.dataSourceOrderLoan = data[0];


      this.selectedVisits = this.dataSourceOrderLoan.data
        .filter(item => item.address?.geolocationPoint.length > 0)
        .map(item => ({
          geoPoint: item.address.geolocationPoint,  // { latitude, longitude }
          id: item.shipTo?.externalKeys?.code,
          serials: item.serial,
          title: item.shipTo?.name,
        }));


      const dataChargePartners = await this.getOrdersGroupedByCustomers(
        this.pageSizeLoan,
        this.currentPage,
        sortField,
        tripId,
        document
      );

      const dataChargeMaterial = await this.getOrdersGroupedByMaterial(
        this.pageSizeLoan,
        this.currentPage,
        sortField,
        tripId,
        document,
      );

      this.chargeTotalItems = dataChargePartners[0]?.pageInfo?.[0]?.total ?? 0;
      this.dataSourceChargePartners = new MatTableDataSource(
        dataChargePartners[0].data || []
      );

      this.dataSourceChargePartners.data =
        this.dataSourceChargePartners.data.map((item) => ({
          ...item,
          total: item.orders.reduce(
            (sum, order) => sum + (order.total || 0),
            0
          ),
        }));

      this.updateCompanyFieldsFromOrders(this.dataSourceChargePartners);

      this.dataSourceChargeMaterials = new MatTableDataSource(
        dataChargeMaterial[0].data || []
      );

      const initialStatus = {
        countDocument: 0,
        notAllowedSync: 0, // Sin statusERP
        notSynchronization: 0,  // statusERP = OrderStatusERPEnum.ORDER_ERROR_ERP, OrderStatusERPEnum.ORDER_ERROR
        loadSynchronization: 0, // statusERP = OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE, OrderStatusERPEnum.ORDER_RECEIVED, OrderStatusERPEnum.ORDER_PENDING, OrderStatusERPEnum.ORDER_SEND
        synchronization: 0, // statusERP OrderStatusERPEnum.ORDER_CREATED
      };

      this.statusDocumentCharge = data.counts.reduce(
        (acc, item) => {
          const count = item.count || 0;

          switch (item.syncStatus) {
            case "notSynchronized":
              acc.notSynchronization = count;
              break;

            case "toSynchronized":
              acc.loadSynchronization = count;
              break;

            case "Synchronized":
              acc.synchronization = count;
              break;
          }

          acc.countDocument += count;

          return acc;
        },
        { ...initialStatus }
      );
    } catch (error) {
      this.snackBar.open(error.error.message || "Error al cargar la información.", "Cerrar", { duration: 5000 });
    }
  }

  updateCompanyFieldsFromOrders(data): void {
    if (!data?.data?.length) return;

    const firstOrder = data.data[0]?.orders?.[0];
    if (!firstOrder?.company) return;

    const company = this.companyList.find(
      (c) => c.id === firstOrder.company.id
    );
    if (!company) return;

    this.UMPActive = company.UMPActive;
    this.totalUnit = company?.currencyBase?.code ?? "";
  }

  onPageChangeTrasport(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;
    this.pageSizeLoan = event.pageSize;
    this.loadDataTransport(this.selectedMR);
  }

  onDataRefreshedTransport() {
    this.currentPage = this.paginator.pageIndex + 1;
    this.loadDataTransport(this.selectDocumentGroup);
    this.setActiveTab(this.activeTabIndex);
  }

  async loadDataTransport(dataSelect) {
    try {
      const sortField = "createdAt";
      const tripId = this.selectedMR.id ?? dataSelect.id;
      const documentT = [DocumentTypeEnum.DOCUMENTO_DE_TRANSPORTE];

      const dataTransport = await this.findAllWithCountForDocument(
        this.pageSizeLoan,
        this.currentPage,
        sortField,
        tripId,
        documentT
      );

      this.dataSourceTransport = dataTransport[0];
    } catch (error) {
      this.snackBar.open(error.error.message || "Error al cargar la información.", "Cerrar", { duration: 5000 });
    }
  }

  onPageChangeData(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;
    this.pageSizeLoan = event.pageSize;
    this.loadDataDeliveryLoan(this.selectedMR);
  }

  public onLoandDelivery() {
    this.loadDataDeliveryLoan(this.selectedMR);
  }

  async loadDataDeliveryLoan(dataSelect) {
    try {
      const sortField = "shipTo.name";
      const tripId = dataSelect.id;
      const document = [DocumentTypeEnum.ENTREGA_SALIDA];
      const materialSummaryTabDocumentType = [DocumentTypeEnum.ENTREGA_SALIDA];
      const isDirectSale = true;
      const data = await this.findAllWithCountForDocument(
        this.pageSizeLoan,
        this.currentPage,
        sortField,
        tripId,
        document,
        [],
        isDirectSale,
      );

      this.dataSourceDeliveryLoan = data[0];

      this.selectedDelivery = this.dataSourceDeliveryLoan.data
        .filter(item => item.address?.geolocationPoint.length > 0)
        .map(item => ({
          geoPoint: item.address.geolocationPoint,  // { latitude, longitude }
          id: item.shipTo?.externalKeys?.code,
          serials: item.serial,
          title: item.shipTo?.name,
        }));


      this.deliveryUnified = this.verifidUnified(
        this.dataSourceDeliveryLoan.data
      );

      const initialStatus: statusDocumentDelivery = {
        countDocument: 0,
        notDelivered: 0,
        delivered: 0,
        loadDelivered: 0,
      };

      this.statusDocumentDelivery = data.deliveryStatus.reduce(
        (acc, item) => {
          const count = item.count || 0;

          switch (item.deliveryStatus) {
            case "notDelivered":
              acc.notDelivered = count;
              break;

            case "delivered":
              acc.delivered = count;
              break;

            case "loadDelivered":
              acc.loadDelivered = count;
              break;
          }

          acc.countDocument += count;

          return acc;
        },
        { ...initialStatus }
      );

      const dataDeliveryPartners = await this.getOrdersGroupedByCustomers(
        this.pageSizeLoan,
        this.currentPage,
        sortField,
        tripId,
        document
      );

      const dataDeliveryMaterial = await this.getOrdersGroupedByMaterial(
        this.pageSizeLoan,
        this.currentPage,
        sortField,
        tripId,
        materialSummaryTabDocumentType,
        isDirectSale
      );

      this.deliveryTotalItems =
        dataDeliveryPartners[0]?.pageInfo?.[0]?.total ?? 0;
      this.dataSourceDeliveryPartners = new MatTableDataSource(
        dataDeliveryPartners[0].data || []
      );

      this.dataSourceDeliveryPartners.data =
        this.dataSourceDeliveryPartners.data.map((item) => ({
          ...item,
          total: item.orders.reduce(
            (sum, order) => sum + (order.total || 0),
            0
          ),
        }));

      this.updateCompanyFieldsFromOrders(this.dataSourceDeliveryPartners);

      this.dataSourceDeliveryMaterials = new MatTableDataSource(
        dataDeliveryMaterial[0].data || []
      );

    } catch (error) {
      this.snackBar.open(error.error.message || "Error al cargar la información.", "Cerrar", { duration: 5000 });
    }
  }

  async loadDataDocumentClient(dataSelect) {
    try {
      const sortField = "createdAt";
      const tripId = this.selectedMR.id;
      const document = [DocumentTypeEnum.FACTURA, DocumentTypeEnum.ENTREGA_SALIDA];


      const data = await this.findAllWithCountForClient(
        this.pageSizeLoan,
        this.currentPage,
        sortField,
        tripId,
        document
      );

      this.dataSourceItemsDocuments = data[0].data;
      this.dataSourceItemsDocumentsExport.data = data[0].data;
      this.updateCompanyFieldsFromOrders(this.dataSourceItemsDocuments);
    } catch (error) {
      this.snackBar.open(error.error.message || "Error al cargar la información.", "Cerrar", { duration: 5000 });
    }
  }

  async loadDataDocumentGeneral(typeCodeRaw) {
    try {
      const sortField = "createdAt";
      const tripId = this.selectedMR.id;
      const document = this.normalizeDocumentTypeCode(typeCodeRaw);
      const typeCode = this.extractRawTypeCode(typeCodeRaw);

      // Caso especial para DocumentTypeEnum.DOCUMENTO_DE_PAGO (pagos)
      if (typeCode === DocumentTypeEnum.DOCUMENTO_DE_PAGO) {
        const data = await this.getOrdersPayment(
          this.pageSizeLoan,
          this.currentPage,
          sortField,
          tripId,
          document
        );

        if (data[0]) {
          // Filtrar solo pagos no FACTURA_AVE
          data[0].data = data[0].data.filter(
            (item) => item.codeReason !== PaymentReasonEnum.FACTURA_AVE
          );
        }
        return data[0];
      }

      const data = await this.findAllWithCountForDocument(
        this.pageSizeLoan,
        this.currentPage,
        sortField,
        tripId,
        document
      );

      // if (typeCode === DocumentTypeEnum.FACTURA && data[0]) {
      //   data[0].data = data[0].data.filter(
      //     (item) => item.statusId !== StatusEnum.INACTIVE
      //   );
      // }

      return data;
    } catch (error) {
      this.snackBar.open(error.error.message || "Error al cargar la información.", "Cerrar", { duration: 5000 });
    }
  }


  normalizeDocumentTypeCode(input) {
    if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'object') {
      return [input[0].typeCode];
    } else if (typeof input === 'object' && input !== null && 'typeCode' in input) {
      return [input.typeCode];
    } else if (typeof input === 'string') {
      return [input];
    } else {
      return [];
    }
  }

  extractRawTypeCode(input) {
    if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'object') {
      return input[0].typeCode;
    } else if (typeof input === 'object' && input !== null && 'typeCode' in input) {
      return input.typeCode;
    } else if (typeof input === 'string') {
      return input;
    } else {
      return null;
    }
  }

  async loadPayments(typeCode) {
    try {
      const sortField = "createdAt";
      const tripId = this.selectedMR.id;
      const document = [typeCode];

      const data = await this.getOrdersPayment(
        this.pageSizeLoan,
        this.currentPage,
        sortField,
        tripId,
        document
      );

      //DocumentTypeEnum.DOCUMENTO_DE_CARGA
      //Se flitra por statusId: StatusEnum.ACTIVE,StatusEnum.ORDER_DELIVERED,StatusEnum.ORDER_PARTIAL_DELIVERED,StatusEnum.ORDER_DELIVERY_REJECTED
      return data[0];
    } catch (error) {
      this.snackBar.open(error.error.message || "Error al cargar la información.", "Cerrar", { duration: 5000 });
    }
  }

  async loadPaymentsGeneral(dataSelect) {
    try {
      const sortField = "createdAt";
      const sortFieldTotal = "paymentType.name";
      const tripId = dataSelect.id;
      const document = [DocumentTypeEnum.DOCUMENTO_DE_PAGO];

      const data = await this.getOrdersPayment(
        this.pageSizeLoan,
        this.currentPage,
        sortFieldTotal,
        tripId,
        document
      );

      this.dataSourcePayments = data[0].data;

      const invoice = await this.findAllWithCountForInvoice(
        this.pageSizeLoan,
        this.currentPage,
        sortField,
        tripId,
        [DocumentTypeEnum.FACTURA],
        [0],
      );

      const validInvoices = invoice?.[0]?.data || [];

      // 4. Filtrar pagos asociados a facturas no anuladas
      const validPayments = data[0].data.filter(payment =>
        validInvoices.some(invoice =>
          invoice.serial === payment.document // Relación pago-factura
        )
      );

      // 5. Calcular total solo con pagos válidos
      this.totalPaying += this.calculateTotalMethod(validPayments, 'paying');
      this.totalOverPayment = this.calculateTotalMethod(validPayments, 'overpayment');
      this.dataSourcePayments = new MatTableDataSource<GroupedPayment>(this.groupPayments(validPayments));


    } catch (error) {
      this.snackBar.open(error.error.message || "Error al cargar la información.", "Cerrar", { duration: 5000 });
    }
  }

  // Función para calcular el total del campo paying o overpayment
  calculateTotalMethod(payments: any, method: 'paying' | 'overpayment'): number {
    if (!payments || !Array.isArray(payments)) return 0;

    return payments.reduce((total, payment) => {
      const amount = Number(payment[method]) || 0;
      return total + amount;
    }, 0);
  }

  private groupPayments(payments: OrderPaymentAttributes[]): GroupedPayment[] {
    const grouped = {};

    payments.forEach(payment => {
      let key = payment.paymentType?.code || 'unknown';
      let groupKey = key;

      const hasBankDetails = payment.bank && payment.account;

      if (hasBankDetails) {
        groupKey = `${key}_${payment.bank.code}_${payment.account.accountNumber}`;
      }

      if (!grouped[groupKey]) {
        grouped[groupKey] = {
          paymentType: payment.paymentType,
          ...(hasBankDetails && {
            bank: payment.bank,
            account: payment.account
          }),
          totalPaying: 0,
          totalOverPayment: 0,
          originalPayments: [],
        };
      }
      grouped[groupKey].totalPaying += payment.paying || 0;
      grouped[groupKey].totalOverPayment += payment.overpayment || 0;
      grouped[groupKey].originalPayments.push(payment);
    });

    return Object.values(grouped);
  }

  openCreditNoteDetail(groupedPayment: any): void {
    const detailDataSource = new MatTableDataSource(groupedPayment.originalPayments);
    this.dialog.open(CreditNoteDialogComponent, {
      width: '800px',
      data: detailDataSource.data,
      autoFocus: false
    });
  }

  async loadExpenseDocuments(dataSelect) {
    const initialStatus = {
      countDocument: 0,
      notAllowedSync: 0,
      notSynchronization: 0,
      loadSynchronization: 0,
      synchronization: 0,
    };

    this.tripIdExpense = dataSelect.id;
    let options: IPagination<ExpenseAttributes> = {
      currentPage: 1,
      limitPerPage: 20,
      sort: "_id",
      sortDirection: SortDirectionEnum.DESC,
    };

    let filter: IFilters = {
      tripId: this.tripIdExpense,
    }

    const data = await this.expenseService
      .findAllWithCount(
        options,
        filter
      )
      .subscribe({
        next: (res: IPaginationResult<ExpenseAttributes>) => {
          this.dataSourceExpenses.data = res?.data?.[0]?.data ?? [];
          this.totalItemsExpense = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;

          this.statusDocument = this.dataSourceExpenses.data.reduce(
            (acc, item) => {
              const loadSync = [0, 1, 2, 5];
              const sync = [3];
              const notSync = [4, 6];

              if (loadSync.includes(item.statusERP)) {
                acc.loadSynchronization += 1;
              } else if (sync.includes(item.statusERP)) {
                acc.synchronization += 1;
              } else if (notSync.includes(item.statusERP)) {
                acc.notSynchronization += 1;
              }

              acc.countDocument += 1;

              return acc;
            },
            { ...initialStatus }
          );

          this.totalPaying += this.dataSourceExpenses.data.reduce(
            (acc, item) => acc + (item.amount || 0),
            0
          );
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al obtener reporte",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  async loadDataDocument(dataSelect) {
    try {
      const pageSize = 100;
      const currentPage = 1;
      const sortField = "createdAt";
      const tripId = dataSelect.id;
      const document = [DocumentTypeEnum.ENTREGA_ENTRADA, DocumentTypeEnum.DOCUMENTO_DE_CARGA, DocumentTypeEnum.DOCUMENTO_DE_TRANSPORTE, DocumentTypeEnum.ENTREGA_SALIDA];
      const data = await this.findAllWithCountForDocumentNotIn(
        pageSize,
        currentPage,
        sortField,
        tripId,
        document
      );


      this.groupDocuments = await this.fechtDocumentTypes();

      const initialStatus = {
        countDocument: 0,
        notAllowedSync: 0,
        notSynchronization: 0,
        loadSynchronization: 0,
        synchronization: 0,
      };


      this.statusDocument = data.counts.reduce(
        (acc, item) => {
          const count = item.count || 0;

          switch (item.syncStatus) {
            case "notAllowedSync":
              acc.notAllowedSync = count;
              break;

            case "notSynchronized":
              acc.notSynchronization = count;
              break;

            case "toSynchronized":
            case "partialSync":
              acc.loadSynchronization += count;
              break;

            case "Synchronized":
              acc.synchronization = count;
              break;
          }

          acc.countDocument += count;

          return acc;
        },
        { ...initialStatus }
      );
    } catch (error) {
      this.snackBar.open(error.error.message || "Error al cargar la información. ", "Cerrar", { duration: 5000 });
    }
  }

  async loadDataVisit(dataSelect) { //aqui
    try {
      const pageSize = 100;
      const currentPage = 1;
      const sortField = "dateTimeStart";
      const tripId = dataSelect.id;

      const data = await this.findAllWithCountByTripMonitor(
        pageSize,
        currentPage,
        sortField,
        tripId
      );
      this.dataSourceItemsRoutes = data[0].data;
      this.dataSourceItemsRoutes = this.calculateTimeVisit(
        this.dataSourceItemsRoutes
      );
      this.statusRoute = this.calculateVisitValid(this.dataSourceItemsRoutes);
    } catch (error) {
      this.snackBar.open(error.error.message || "Error al obtener visitas.", "Cerrar", { duration: 5000 });
    }
  }

  async loadWorkProgressMaterials(dataSelect: any) {
    try {
      this.isLoadingWorkProgressMaterials = true;
      this.workProgressMaterialData = null;

      const response = await this.orederService.getWorkInProgressMaterialsComplete(
        dataSelect.id
      );

      this.workProgressMaterialData = response;

    } catch (error) {
      this.workProgressMaterialData = null;
    } finally {
      this.isLoadingWorkProgressMaterials = false;
    }
  }

  /**
   * Called when the work progress materials component initializes
   * This will load data if needed
   */
  onWorkProgressMaterialsInit() {
    // Only load if we have a selected trip and no data yet
    if (this.selectedMR && !this.workProgressMaterialData && !this.isLoadingWorkProgressMaterials) {
      this.loadWorkProgressMaterials(this.selectedMR);
    }
  }

  private calculateTimeVisit(visits: VisitAttributes[]) {
    return visits?.map((route: VisitAttributes) => {
      if (route?.dateTimeStart && route?.dateTimeEnd) {
        const start = new Date(route.dateTimeStart);
        const end = new Date(route.dateTimeEnd);
        const duration = end.getTime() - start.getTime();
        const hours = Math.floor(duration / (1000 * 60 * 60));
        const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((duration % (1000 * 60)) / 1000);

        return {
          ...route,
          duration: `${hours
            .toString()
            .padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds
              .toString()
              .padStart(2, "0")}`,
        };
      }

      return route;
    });
  }

  // Tabla Documentos de carga
  public toggleDetailsCharge(dataSelect: ClientOrder): void {
    if (
      this.selectedCharge &&
      this.selectedCharge.shipTo._id === dataSelect.shipTo._id
    ) {
      this.selectedCharge = null;
      return;
    }

    this.selectedCharge = dataSelect;

    this.dataSourceItemsSubCharge = new MatTableDataSource(
      this.selectedCharge?.orders || []
    );
    // REMOVED: asignarSortsTableSubCharge call - now using smart-grid which handles sorting automatically
  }

  // REMOVED: selectedItemCharge - now using smart-grid row expansion state

  // REMOVED: toggleDetailItemsCharge method - smart-grid handles row expansion automatically

  // Tabla Documentos Principal
  public toggleDetailsDocument(dataSelect: any): void {
    if (this.selectedDocument && this.selectedDocument.id === dataSelect.id) {
      this.selectedDocument = null;
    } else {
      this.selectedDocument = dataSelect;

      this.dataSourceItemsSubDocuments = new MatTableDataSource(
        dataSelect.orders
      );
      // this.onFilterDetail(dataSelect);
    }

    setTimeout(() => {
      this.asignarSortsTableSubDocument();
    });
  }

  public async activeExpenses() {
    this.expenseListActive = !this.expenseListActive;
  }

  // Trabajo en curso
  public async toggleItemGroup(itemSelect) {
    this.dataSourceItemsFact.data = [];
    this.dataSourceItemsMerma.data = [];
    this.dataSourceItemsDevo.data = [];

    if (
      this.selectDocumentGroup?.typeCode &&
      this.selectDocumentGroup?.typeCode === itemSelect.typeCode
    ) {
      this.selectDocumentGroup = null;
    } else {
      const response = await this.loadDataDocumentGeneral(itemSelect.typeCode);
      itemSelect.items = response?.[0] || null;
      if (itemSelect.typeCode === DocumentTypeEnum.FACTURA) {
        const payments = await this.loadPayments(DocumentTypeEnum.DOCUMENTO_DE_PAGO);
        itemSelect.relatedPaymentsCache = payments;
      }
      this.selectDocumentGroup = itemSelect;
    }
  }

  // Recorrido
  toggleShip(detail: any): void {
    if (this.selectedShip && this.selectedShip.serial === detail.serial) {
      this.selectedShip = null;
    } else {
      this.selectedShip = detail;
      this.dataSourceMaterialDocuments = new MatTableDataSource(
        detail?.detail
      );
    }
  }

  // Payments inner toggle
  toggleInner(payment: GroupedPayment): void {
    if (this.selectedInner && this.selectedInner.id === payment.id) {
      this.selectedInner = null;
    } else {
      this.selectedInner = payment;
    }
  }

  // open modal
  openDistributionModal(): void {
    /*
    this.dataSourceDistributionDetail.data = [
      { ...item, totalUmp: 100, totalUmb: 50 },
    ];
    */
    this.distributionSpare();
    if (true) {
      const dialogRef = this.dialog.open(ModalDistributionComponent, {
        width: "90%",
        //height: "80%",
        data: {
          data: this.deliveryGroupUnified.data,
          isSaveDistribution: this.isSaveDistribution,
          tripId: this.selectedMR.id,
          UMPActive: this.UMPActive
        },
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.pageIndexMaterial = 0;
          this.onLoandDelivery()
        }
      })
    } else {
      this.dialogReEdit = this.dialog.open(this.editModalDistribution, {
        panelClass: "form-modal-update",
        disableClose: true,
      });
      this.dialogReEdit.afterClosed().subscribe((result) => {
        result ? this.saveMaterialDistribution() : (this.pageIndexMaterial = 0);
      });
    }
  }

  // Toogle groupUnified
  public toggleGroupUnified(dataSelect: any): void {
    if (this.selectGroupUnified?.noDto.serial === dataSelect.noDto.serial) {
      this.selectGroupUnified = null;
    } else {
      this.selectGroupUnified = dataSelect;

      this.deliveryGroupMaterialUnified = new MatTableDataSource(
        dataSelect.items
      );
    }
    this.showButtonSpare = false;
  }

  // Toggle Distribucion
  public toggleDistribution(dataSelect: any): void {
    const dataSelectId = dataSelect.material._id + dataSelect.serial;
    const dataItemId =
      this.selectItemDistribution?.material._id +
      this.selectItemDistribution?.serial;

    if (this.selectItemDistribution && dataSelectId === dataItemId) {
      this.selectItemDistribution = null;
    } else {
      this.selectItemDistribution = dataSelect;
      const newDetail = this.selectNew();
      this.dataSourceDistributionItemDetail = new MatTableDataSource(
        dataSelect.orderdetail.map(item => ({
          ...item,
          selectedUnit: 'UMB',
          isNew: newDetail &&
            item.position === newDetail.position &&
            dataSelect.material?._id == newDetail.material?._id
        }))
      );
      this.showButton = this.dataSourceDistributionItemDetail.data.length == 0 ? true : false;
      this.showButtonSpare = this.selectItemDistribution?.spare > 0 ? true : false;
    }
  }

  private distributionSpare() {
    const spare: number =
      this.deliveryGroupMaterialUnified.data.reduce(
        (acc: number, item: any) => acc + item.spare,
        0
      ) ?? 0;
    this.isSaveDistribution = spare === 0;
  }

  public onHandleEditUMBDetail(itemSelect) {
    itemSelect.edit = itemSelect.edit ? false : true;

    if (!itemSelect.selectedUnit) {
      itemSelect.selectedUnit = 'UMB';
    }

    this.distributionSpare();
    this.dataSourceDistributionItemDetail.data = [
      ...this.dataSourceDistributionItemDetail.data,
    ];
  }

  public formatDetailsOrder(orders) {
    return orders.flatMap((order) => {
      return order?.detail?.map((item) => ({
        ...item,
        reference: order?.sourceTransaction?.serial,
        serial: order.serial,
        typeName: order?.type?.name,
        noBilling: order?.nextTransaction?.serial,
      }));
    });
  }

  onHandleDetailOrder(serial: string) {
    if (serial) {
      this.fetchOrderBySerial(serial);
    }
  }

  // Modal vista de documetno unificados detalles
  openDistributionModalDetails(serial: string): void {
    this.dialog.open(this.viewDocumentModal, {
      data: {
        serial: serial,
      },
      panelClass: "form-modal-update",
      disableClose: true,
    });
    this.dialogReEdit.afterClosed().subscribe((result) => { });
  }

  public onDetailsDocuemnt() {
    this.isVisibleDetailsDoc = !this.isVisibleDetailsDoc;
  }

  public onDetailsLoan() {
    this.isVisibleLoan = !this.isVisibleLoan;
    if (!this.isVisibleLoan) {
      this.windowState.closeWindow('documents', true); // Fuerza el cierre del mapa
    }
  }

  public onDetailsDelivery() {
    this.isVisibleDelivery = !this.isVisibleDelivery;
    if (!this.isVisibleDelivery) {
      this.windowState.closeWindow('deliveries', true); // Fuerza el cierre del mapa
    }
  }

  private asignarSortsTableMainCharge() {
    this.dataSourceItemsCharge.sortingDataAccessor = (
      data: any,
      headerId: string
    ) => {
      switch (headerId) {
        case "businesspartner":
          return data.businesspartner.code?.toLowerCase() || "";
        case "noDocument":
          return data.noDocument;
        case "dateHourDelivery":
          return data.dateHourDelivery;
        case "cntLoad":
          return data.cntLoad;
        case "total":
          return data.total;
        default:
          return "";
      }
    };

    if (this.sortMainTableCharge) {
      this.dataSourceItemsCharge.sort = this.sortMainTableCharge;
    }
  }

  // REMOVED: asignarSortsTableSubCharge - smart-grid handles sorting automatically

  private asignarSortsTableMainDocument() {
    this.dataSourceItemsDocuments.sortingDataAccessor = (
      data: any,
      headerId: string
    ) => {
      switch (headerId) {
        case "businesspartner":
          return data.businesspartner.code?.toLowerCase() || "";
        case "ctnMaterials":
          return data.ctnMaterials;
        case "price":
          return data.price;
        case "load":
          return data.load;
        case "visits":
          return data.type;
        default:
          return "";
      }
    };

    if (this.sortTableMainDocument) {
      this.dataSourceItemsDocuments.sort = this.sortTableMainDocument;
    }
  }

  private asignarSortsTableSubDocument() {
    this.dataSourceItemsSubDocuments.sortingDataAccessor = (
      data: any,
      headerId: string
    ) => {
      switch (headerId) {
        case "material":
          return data.material.code?.toLowerCase() || "";
        case "price":
          return data.price;
        case "cntLoad":
          return data.cntLoad;
        case "noRequest":
          return data.noRequest;
        case "noDelivery":
          return data.noDelivery;
        case "noBilling":
          return data.noBilling;
        default:
          return "";
      }
    };

    if (this.sortTableSubDocument) {
      this.dataSourceItemsSubDocuments.sort = this.sortTableSubDocument;
    }
  }

  // Tab Recorrido
  public openImageCarousel(images: any[]) {
    const imageLinks = images.map((image) => image.image.link);
    const dialogRef = this.dialog.open(ImageCarouselComponent, {
      panelClass: "form-modal",
      disableClose: true,
      data: { images: imageLinks },
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  /**
   * Opens the audit log viewer for a trip
   */
  openTripAuditLog(trip: TripAttributes): void {
    this.auditLogViewerService.open({
      collectionName: AUDIT_LOG_COLLECTIONS.TRIP,
      documentIdentifiers: { _id: (trip as any)._id?.toString() },
    });
  }

  onGridReadyVisits(event: GridReadyEvent<VisitAttributes>): void {
    setTimeout(() => {
      event.api.autoSizeAllColumns();
    }, 100);
  }

  findAllTypeDocument(): void {
    const pageIndex = 1;
    const sortDirection: SortDirectionEnum = SortDirectionEnum.ASC;

    this.documentTypeService
      .findAllWithCount({
        currentPage: pageIndex,
        limitPerPage: 100,
        search: "",
        sortDirection: sortDirection,
      },
      )
      .subscribe((data) => {
        this.documentTypeList = data?.data?.[0]?.data ?? [];
        this.documentTypeList = this.documentTypeList.filter(
          (item) =>
            item.code !== DocumentTypeEnum.DOCUMENTO_DE_CARGA &&
            item.code !== DocumentTypeEnum.ENTREGA_SALIDA &&
            item.code !== DocumentTypeEnum.DOCUMENTO_DE_TRANSPORTE &&
            item.code !== DocumentTypeEnum.ENTREGA_ENTRADA
        );
      });
  }

  async synchronizeOrders(orders: OrderAttributes[], type: string) {
    this.fetchDocumentClass(type);

    // 1. Validar todos los pedidos
    const validationResults = await Promise.all(
      orders.map((order) => this.validateDataToSynchronize(order))
    );
    // 2. Separar pedidos válidos e inválidos
    const validOrders = orders.filter((_, index) => validationResults[index]);
    const invalidOrders = orders.filter(
      (_, index) => !validationResults[index]
    );

    if (invalidOrders.length > 0) {
      this.snackBar.open(
        `${invalidOrders.length} documentos no pasaron la validación y se omitirán`,
        "Cerrar",
        { duration: 3000 }
      );
    }

    // 4. Si no hay pedidos válidos, salir
    if (validOrders.length === 0) {
      return;
    }

    // 5. Sincronizar solo los válidos
    let dataToSendPost = { TripIds: [], orderIds: [], method: "POST" };
    let dataToSendPut = { TripIds: [], orderIds: [], method: "PUT" };

    validOrders.forEach((o) => {
      if (o.externalKeys?.code) {
        dataToSendPut.orderIds.push(o._id.toString());
      } else {
        dataToSendPost.orderIds.push(o._id.toString());
      }
    });

    const requests = [];
    if (dataToSendPost.orderIds.length > 0) {
      requests.push(
        this.ordersListService.synchronizeOrders(dataToSendPost).toPromise()
      );
    }
    if (dataToSendPut.orderIds.length > 0) {
      requests.push(
        this.ordersListService.synchronizeOrders(dataToSendPut).toPromise()
      );
    }

    if (requests.length === 0) {
      this.snackBar.open("No se encontraron registros pendientes de sincornizar con ERP.", "Cerrar", { duration: 5000 });
    }

    Promise.all(requests)
      .then(() => {
        this.snackBar.open(
          `${validOrders.length} documentos sincronizados con éxito`,
          "Cerrar",
          { duration: 3000 }
        );
      })
      .catch((err) => {
        this.snackBar.open(err.error.message || "Error al sincronizar con el ERP.", "Cerrar", { duration: 5000 });
      });
  }

  async synchronizeOrdersIn(orders: Array<{ typeCode: string; items: any[] }>) {
    if (!orders?.length) {
      this.snackBar.open("No hay documentos para procesar", "Cerrar", {
        duration: 3000,
      });
      return;
    }

    try {
      // Procesar cada grupo de documentos por typeCode
      for (const group of orders) {
        const { typeCode, items } = group;

        if (!items?.length) {
          continue;
        }


        // Cargar clases de documento para este typeCode
        await this.fetchDocumentClassIn(typeCode);

        // Procesamiento especial para pagos (DocumentTypeEnum.DOCUMENTO_DE_PAGO)
        if (typeCode === DocumentTypeEnum.DOCUMENTO_DE_PAGO) {
          await this.processPayments(items);
          continue;
        }

        // Validación especial para DocumentTypeEnum.DOCUMENTO_DE_PAGO
        let validationResults: boolean[];

        validationResults = await Promise.all(
          items.map((item) => this.validateDataToSynchronize(item))
        );

        // 2. Separar items válidos e inválidos
        const validItems = items.filter((_, index) => validationResults[index]);
        const invalidItems = items.filter(
          (_, index) => !validationResults[index]
        );

        if (invalidItems.length > 0) {
          this.snackBar.open(
            `${invalidItems.length} documentos no pasaron la validación en grupo ${typeCode}`,
            "Cerrar",
            { duration: 3000 }
          );
        }

        // 3. Si no hay items válidos en este grupo, continuar con el siguiente
        if (validItems.length === 0) {
          continue;
        }

        // 4. Sincronizar solo los válidos de este grupo
        let dataToSendPost = { TripIds: [], orderIds: [], method: "POST" };
        let dataToSendPut = { TripIds: [], orderIds: [], method: "PUT" };
        validItems.forEach((item) => {
          if (item.externalKeys?.code) {
            dataToSendPut.orderIds.push(item._id.toString());
          } else {
            dataToSendPost.orderIds.push(item._id.toString());
          }
        });

        const requests = [];
        if (dataToSendPost.orderIds.length > 0) {
          requests.push(
            this.ordersListService
              .synchronizeOrdersOther(dataToSendPost)
              .toPromise()
          );
        }
        if (dataToSendPut.orderIds.length > 0) {
          requests.push(
            this.ordersListService
              .synchronizeOrdersOther(dataToSendPut)
              .toPromise()
          );
        }

        if (requests.length === 0) {
          this.snackBar.open("No se encontraron registros pendientes de sincornizar con ERP.", "Cerrar", { duration: 5000 });
        }

        await Promise.all(requests)
          .then(() => {
            this.snackBar.open(
              `${validItems.length} documentos sincronizados con éxito (${typeCode})`,
              "Cerrar",
              { duration: 3000 }
            );
          })
          .catch((err) => {
            this.snackBar.open(err.error.message || "Error al sincronizar con el ERP.", "Cerrar", { duration: 5000 });
          });
      }

      this.snackBar.open("Proceso de sincronización completado", "Cerrar", {
        duration: 3000,
      });
    } catch (error) {
      this.snackBar.open("Error en el proceso de sincronización", "Cerrar", {
        duration: 3000,
      });
    }
  }

  // Método para procesar pagos (DocumentTypeEnum.DOCUMENTO_DE_PAGO)
  private async processPayments(items: any[]) {
    // 1. Validar pagos
    const validationResults = await Promise.all(
      items.map((item) => this.validateDataToSynchronizePayment(item))
    );
    // 2. Filtrar items válidos
    const validPayments = items.filter((_, index) => validationResults[index]);
    const invalidCount = items.length - validPayments.length;

    if (invalidCount > 0) {
      this.snackBar.open(
        `${invalidCount} pagos no pasaron validación`,
        "Cerrar",
        { duration: 3000 }
      );
    }

    if (validPayments.length === 0) {
      return;
    }

    // 3. Preparar y enviar datos de pagos
    const paymentData = {
      payments: validPayments.map((payment) => ({
        serial: payment.serials,
      })),
    };

    let paymentSerials = [];

    paymentSerials.forEach((serial) => {
      paymentData.payments.push({ serial: serial });
    });

    await this.paymentIntegratorService.sincronize(paymentSerials).toPromise();

    this.snackBar.open(
      `${validPayments.length} pagos sincronizados correctamente`,
      "Cerrar",
      { duration: 3000 }
    );
  }

  validateDataToSynchronize(order: OrderAttributes) {
    return validateOrdersByAction([order], this.documentClassesList, "SYNC");
  }

  validateDataToSynchronizePayment(order: OrderPaymentAttributes) {
    return validateOrdersByActionForPayment(
      [order],
      this.documentClassesList,
      "SYNC"
    );
  }

  exportChargeToExcel = () => {
    if (!this.chargePartnerExport.canStartTask(CHARGE_PARTNER_EXPORT_ID)) return;

    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: CHARGE_PARTNER_TITLE },
    });

    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        // this.chargePartnerExport.setData(this.dataSourceChargePartners.data);
        this.chargePartnerExport.export(
          options.format,
          options.range,
          this.chargeTotalItems,
          CHARGE_PARTNER_EXPORT_ID,
          CHARGE_PARTNER_TITLE,
          this.pageSizeLoan,
          this.currentPage,
          this.selectedMR.id,
          [DocumentTypeEnum.DOCUMENTO_DE_CARGA],
          this.searchDocument
        );
      }
    });
  };

  exportDeliveryToExcel = () => {
    if (!this.chargePartnerExport.canStartTask(DELIVERY_PARTNER_EXPORT_ID)) return;

    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: DELIVERY_PARTNER_TITLE },
    });

    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        // this.chargePartnerExport.setData(this.dataSourceDeliveryPartners.data);
        this.chargePartnerExport.export(
          options.format,
          options.range,
          this.deliveryTotalItems,
          DELIVERY_PARTNER_EXPORT_ID,
          DELIVERY_PARTNER_TITLE,
          this.pageSizeLoan,
          this.currentPage,
          this.selectedMR.id,
          [DocumentTypeEnum.ENTREGA_SALIDA, DocumentTypeEnum.DOCUMENTO_DE_TRANSPORTE],
          this.searchDocument
        );
      }
    });
  };

  exportCustomers = () => {
    if (!this.workCourseCustomerExport.canStartTask()) return;

    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: WORK_COURSER_CUSTOMER_TITLE },
    });

    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        const formattedData = this.dataSourceItemsDocumentsExport.data.flatMap((item: any) =>
          (item.orders ?? []).flatMap((order: any) =>
            (order.detail ?? []).map((detail: any) => {
              const newItem = {
                ...item,
                orders: [
                  {
                    ...order,
                    detail: [detail],
                  },
                ],
              };

              CURRENCYFIELDS.forEach((field) => {
                const value = Number(detail[field]);
                if (!isNaN(value)) {
                  detail[field] = FORMATTER.format(value);
                }
              });

              return newItem;
            })
          )
        );

        this.workCourseCustomerExport.setData(formattedData);
        this.workCourseCustomerExport.export(options.format);
      }
    });
  };

  async onDataRefreshed() {
    this.currentPage = this.paginator.pageIndex + 1;

    const data = await this.loadDataDocumentGeneral(this.selectDocumentGroup);
    const typeCode = this.extractRawTypeCode(this.selectDocumentGroup);
    const group = this.groupDocuments?.find((doc) => doc.typeCode === typeCode);
    const items = Array.isArray(data) ? data[0] : data;

    if (group && items) {
      group.items = items;

      if (data?.counts) {
        group.counts = data.counts;
      }
    }

    this.setActiveTab(this.activeTabIndex);
  }

  onDataLoan() {
    this.currentPage = this.paginator.pageIndex + 1;
    this.loadDataOrderLoan(this.selectedMR);
    this.setActiveTab(this.activeTabIndex);
    this.selectedTabIndex = 0;
  }

  closeAndReopenRow() {
    if (this.selectedMR) {
      const currentSelectedMR = { ...this.selectedMR };
      this.selectedMR = null;
      this.cdr.detectChanges();

      setTimeout(() => {
        this.selectedMR = currentSelectedMR;
        this.cdr.detectChanges();
      }, 100);
    }
  }

  setActiveTab(index: number) {
    this.activeTabIndex = index;
  }

  updateTables() {
    if (this.selectedMR) {
      this.statusDocument = this.selectedMR.statusDocument;
      this.statusDocumentCharge = this.selectedMR.statusDocumentCharge;

      this.selectedMR.visits = this.calculateTimeVisit(this.selectedMR.visits);
      // Carga
      this.dataSourceOrderLoan = new MatTableDataSource(
        this.selectedMR?.chargeGroups.loans || []
      );
      this.dataSourceChargePartners = new MatTableDataSource(
        this.selectedMR?.chargeGroups.partners || []
      );

      this.dataSourceChargeMaterials = new MatTableDataSource(
        this.selectedMR?.chargeGroups.materials || []
      );

      // Entregas
      this.dataSourceDeliveryLoan = new MatTableDataSource(
        this.selectedMR?.deliveryGroups.loans || []
      );

      this.dataSourceDeliveryPartners = new MatTableDataSource(
        this.selectedMR?.deliveryGroups.partners || []
      );

      this.dataSourceDeliveryMaterials = new MatTableDataSource(
        this.selectedMR?.deliveryGroups.materials || []
      );

      this.processCombinedDocuments(this.selectedMR?.combinedDocuments);

      this.dataSourceItemsDocuments = new MatTableDataSource(
        this.selectedMR?.documents
      );

      this.dataSourceDocumentsDetails = new MatTableDataSource([
        {
          nroOrder: this.dataSourceItemsDocuments.data.length,
          nroView: 3,
          otherDocuments: 2,
        },
      ]);
      this.cdr.detectChanges();
    }
  }

  openEditModal(item): void {
    this.parameterIdForVehicles = [];
    if (item.vehicle) this.parameterIdForVehicles.push(item.vehicle._id);
    this.dialogReEdit = this.dialog.open(SharedTripEditModalComponent, {
      width: '95%',
      maxWidth: '900px',
      height: '95vh',
      maxHeight: '900px',
      disableClose: true,
      data: { tripId: item._id }
    });

    this.dialogReEdit
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.fetchAllWithCount(this.pageSize, this.pageIndex, null);
        }
      });
  }

  openRefDownloadResumeModal(tripId: number): void {
    this.tripIdDownload = tripId;
    this.dialogRefDownloadResumeModal = this.dialog.open(this.viewDownloadResumeModal, {
      disableClose: true,
      width: '95%',
      maxWidth: '900px',
      maxHeight: '900px',
    });
    this.dialogRefDownloadResumeModal.afterClosed().subscribe((result) => {
      result
    });
  }

  openPurgeDialog(trip: TripAttributes) {
    this.dialog.open(PurgeTripDialogComponent, {
      data: { tripId: trip._id },
      disableClose: true,
      panelClass: 'purge-modal'
    }).afterClosed().subscribe(result => {
      if (result) {
        this.orederService.cancelTrip({
          tripMongoId: String(trip._id),
          method: result.purgeType
        }).subscribe({
          next: (res) => {
            this.snackBar.open("El viaje fue purgado exitosamente", "Cerrar", { duration: 3000 });
            this.fetchAllWithCount(this.pageSize, this.pageIndex, null);
            if (this.selectedMR) {
              this.toggleDetails(trip)
            }
          },
          error: (error) => {
            this.snackBar.open(error.error.message, "Cerrar", { duration: 3000 });
          },
        });
      }
    });
  }

  onCancel() {
    this.dialogRefDownloadResumeModal.close(false);
  }

  statusTrip() {
    this.statusList = TRIP_STATUS_LIST;
  }

  get totalItemsLength(): number {
    return this.groupDocuments.reduce(
      (sum, document) => sum + (document.items?.length || 0),
      0
    );
  }

  private async findAllWithCountForInvoice(
    pageSizeCustom: number,
    pageIndexCustom: number,
    sortActiveCustom,
    tripId: number,
    document_type: string[],
    statusIds?: number[],
    document?: string,
  ): Promise<any> {
    const sortDirection = SortDirectionEnum.ASC;
    try {
      const response = await this.orederService
        .findAllWithCountForInvoice(
          {
            currentPage: pageIndexCustom,
            limitPerPage: pageSizeCustom,
            search: this.searchDocument,
            sort: sortActiveCustom,
            sortDirection: sortDirection,
          },
          tripId,
          document_type,
          statusIds,
          document
        )
        .toPromise();
      return response?.data;
    } catch (error) {
      this.snackBar.open(error.error.message || "Error al obtener pedidos por factura.", "Cerrar", { duration: 5000 });
    }
  }

  private async findAllWithCountForDocument(
    pageSizeCustom: number,
    pageIndexCustom: number,
    sortActiveCustom,
    tripId: number,
    document_type: string[],
    statusIds?: number[],
    isDirectSale?: boolean
  ): Promise<any> {
    const sortDirection = SortDirectionEnum.ASC;
    try {
      const response = await this.orederService
        .findAllWithCountForDocument(
          {
            currentPage: pageIndexCustom,
            limitPerPage: pageSizeCustom,
            search: this.searchDocument,
            sort: sortActiveCustom,
            sortDirection: sortDirection,
          },
          tripId,
          document_type,
          statusIds,
          null,
          isDirectSale
        )
        .toPromise();
      return response?.data;
    } catch (error) {
      this.snackBar.open(error.error.message || "Error al obtener pedidos por documento.", "Cerrar", { duration: 5000 });
    }
  }
  private async findAllWithCountForDocumentNotIn(
    pageSizeCustom: number,
    pageIndexCustom: number,
    sortActiveCustom,
    tripId: number,
    document_type: string[]
  ): Promise<any> {
    const sortDirection = SortDirectionEnum.ASC;

    try {
      const response = await this.orederService
        .findAllWithCountForDocumentNotIn(
          {
            currentPage: pageIndexCustom,
            limitPerPage: pageSizeCustom,
            search: this.searchDocument,
            sort: sortActiveCustom,
            sortDirection: sortDirection,
          },
          tripId,
          document_type
        )
        .toPromise();

      return response?.data;
    } catch (error) {
      this.snackBar.open(error.error.message || "Error al obtener pedidos por documento.", "Cerrar", { duration: 5000 });
    }
  }
  private async getOrdersGroupedByCustomers(
    pageSizeCustom: number,
    pageIndexCustom: number,
    sortActiveCustom,
    tripId: number,
    document_type: string[]
  ): Promise<any> {
    const sortDirection = SortDirectionEnum.ASC;

    try {
      const response = await this.orederService
        .getOrdersGroupedByCustomers(
          {
            currentPage: pageIndexCustom,
            limitPerPage: pageSizeCustom,
            search: this.searchDocument,
            sort: sortActiveCustom,
            sortDirection: sortDirection,
          },
          tripId,
          document_type
        )
        .toPromise();

      const data = response?.data?.[0]?.data;

      // TODO: Remove and type this any
      const clientOrders: ClientOrder[] = data as any;

      return response?.data;
    } catch (error) {
      this.snackBar.open(error.error.message || "Error al obtener pedidos por socio de negocio.", "Cerrar", { duration: 5000 });
    }
  }
  private async getOrdersGroupedByMaterial(
    pageSizeCustom: number,
    pageIndexCustom: number,
    sortActiveCustom,
    tripId: number,
    document_type: string[],
    isDirectSale?: boolean
  ): Promise<any> {
    const sortDirection = SortDirectionEnum.ASC;

    try {
      const response = await this.orederService
        .getOrdersGroupedByMaterial(
          {
            currentPage: pageIndexCustom,
            limitPerPage: pageSizeCustom,
            search: this.searchDocument,
            sort: sortActiveCustom,
            sortDirection: sortDirection,
          },
          tripId,
          document_type,
          isDirectSale
        )
        .toPromise();

      return response?.data;
    } catch (error) {
      this.snackBar.open(error.error.message || "Error al obtener pedidos por material.", "Cerrar", { duration: 5000 });
    }
  }
  private async findAllWithCountForClient(
    pageSizeCustom: number,
    pageIndexCustom: number,
    sortActiveCustom,
    tripId: number,
    document_type: string[]
  ): Promise<any> {
    const sortDirection = SortDirectionEnum.ASC;

    try {
      const response = await this.orederService
        .findAllWithCountForClient(
          {
            currentPage: pageIndexCustom,
            limitPerPage: pageSizeCustom,
            search: this.searchDocument,
            sort: sortActiveCustom,
            sortDirection: sortDirection,
          },
          tripId,
          document_type
        )
        .toPromise();
      return response?.data;
    } catch (error) {
      this.snackBar.open(error.error.message || "Error al obtener pedidos por cliente.", "Cerrar", { duration: 5000 });
    }
  }
  private async getOrdersPayment(
    pageSizeCustom: number,
    pageIndexCustom: number,
    sortActiveCustom,
    tripId: number,
    document_type: string[]
  ): Promise<any> {
    const sortDirection = SortDirectionEnum.ASC;
    try {
      const response = await this.paymentService
        .findAllWithCountByTrip(
          {
            currentPage: pageIndexCustom,
            limitPerPage: pageSizeCustom,
            search: this.searchDocument,
            sort: sortActiveCustom,
            sortDirection: sortDirection,
          },
          tripId,
          document_type
        )
        .toPromise();

      return response?.data;
    } catch (error) {
      this.snackBar.open(error.error.message || "Error al obtener pagos.", "Cerrar", { duration: 5000 });
    }
  }
  private async findAllWithCountByTripMonitor(
    pageSizeCustom: number,
    pageIndexCustom: number,
    sortActiveCustom,
    tripId: number
  ): Promise<any> {
    const sortDirection = SortDirectionEnum.ASC;

    try {
      const response = await this.visitService
        .findAllWithCountByTripMonitor(
          {
            currentPage: pageIndexCustom,
            limitPerPage: pageSizeCustom,
            search: this.searchDocument,
            sort: sortActiveCustom,
            sortDirection: sortDirection,
          },
          tripId
        )
        .toPromise();
      return response?.data;
    } catch (error) {
      this.snackBar.open(error.error.message || "Error al obtener visitas.", "Cerrar", { duration: 5000 });
    }
  }

  async changePage(event: PageEvent): Promise<void> {
    this.pageSizeLoan = event.pageSize;
    this.currentPage = event.pageIndex + 1;

    let documents: string[];

    if (this.activeTable === "delivery") {
      documents = [DocumentTypeEnum.ENTREGA_SALIDA, DocumentTypeEnum.DOCUMENTO_DE_TRANSPORTE];
    } else if (this.activeTable === "charge") {
      documents = [DocumentTypeEnum.DOCUMENTO_DE_CARGA]; // Documentos de carga
    }

    const dataDeliveryPartners = await this.getOrdersGroupedByCustomers(
      this.pageSizeLoan,
      this.currentPage,
      "shipTo.name",
      this.selectedMR.id,
      documents
    );
    if (this.activeTable === "delivery") {
      this.deliveryTotalItems =
        dataDeliveryPartners[0]?.pageInfo?.[0]?.total ?? 0;
      this.dataSourceDeliveryPartners = new MatTableDataSource(
        dataDeliveryPartners[0].data || []
      );
      this.dataSourceDeliveryPartners.data =
        this.dataSourceDeliveryPartners.data.map((item) => ({
          ...item,
          total: item.orders.reduce(
            (sum, order) => sum + (order.total || 0),
            0
          ),
        }));
    } else if (this.activeTable === "charge") {
      this.chargeTotalItems =
        dataDeliveryPartners[0]?.pageInfo?.[0]?.total ?? 0;
      this.dataSourceChargePartners = new MatTableDataSource(
        dataDeliveryPartners[0].data || []
      );
      this.dataSourceChargePartners.data =
        this.dataSourceChargePartners.data.map((item) => ({
          ...item,
          total: item.orders.reduce(
            (sum, order) => sum + (order.total || 0),
            0
          ),
        }));
    }
  }

  setActiveTable(tableType: "delivery" | "charge"): void {
    this.activeTable = tableType;
    this.cdr.markForCheck();
  }

  onSubTabsChange(event: MatTabChangeEvent): void {
    this.subTabActiveIndex = event.index;
    this.resetPagination();

    switch (event.index) {
      case 0: // Transporte
        this.loadDataTransport(this.selectedMR);
        break;
      case 1: // Entregas
        // this.loadTransportData();
        break;
      case 2: // Resumen Material
        // this.loadTransportData();
        break;
      case 3: // Entregas por cliente
        this.setActiveTable("delivery");
        break;
    }
  }

  resetPagination(): void {
    this.currentPage = 1;
    this.pageSizeLoan = 100;

    if (this.paginator) {
      this.paginator.firstPage();
      this.paginator.pageSize = this.pageSizeLoan;
    }
  }

  // Cuando cambia el tab de Trabajo en Curso
  onWorkProgressTabChange(event: MatTabChangeEvent): void {
    this.workInProgressSubTabsIndex = event.index;

    // Solo cargar datos de materiales cuando se selecciona el tab de Materiales (índice 2)
    if (event.index === 2 && this.selectedMR) {
      this.loadWorkProgressMaterials(this.selectedMR);
    }

    if (event.index === 3 && this.selectedMR) {
      this.showExpenseTab = true;
    }
  }

  // Cuando cambia el tab PADRE
  onParentTabChange(event: MatTabChangeEvent): void {
    this.currentParentTab = event.index;
    this.resetPagination();
    if (event.index === 0) {
      this.activeTable = "charge";
      this.loadDataOrderLoan(this.selectedMR);
    } else if (event.index === 1) {
      this.activeTable = "delivery";
      this.loadDataDeliveryLoan(this.selectedMR);
    }
  }

  private calculateVisitValid(visits: VisitAttributes[]): IStatusRoute {
    var visitValid = 0;
    var visitNotValid = 0;
    var countDocument = 0;
    visits?.forEach((visit) => {
      countDocument++;
      if (visit?.validVisit) {
        visitValid++;
      } else {
        visitNotValid++;
      }
    });

    return {
      countDocument,
      visitValid,
      visitNotValid,
    };
  }

  loadMaterilaUnified(id: string) {
    this.pageIndexMaterial = this.pageIndexMaterial + 1;
    this.fetchOrderGroudMaterial(id, true);
  }

  private saveMaterialDistribution() {
    this.pageIndexMaterial = 0;

    const orderIdList = this.dataSourceDistributionItemDetail.data.map(
      (item) => {
        return item._id;
      }
    );
    this.dialogReEdit = this.dialog.open(this.updateDialog, {
      data: {
        title: "Entregas",
        description: "¿Desea confirmar las entregas?",
      },
      panelClass: "form-modal-update",
      disableClose: true,
    });
    this.dialogReEdit.afterClosed().subscribe((result) => {
      if (result) {
        this.fetchupdateOrdeConfirmation({
          tripId: this.selectedMR.id,
          orderId: orderIdList,
        });
      } else {
        this.onLoandDelivery();
      }
    });

    /*
    this.deliveryUnifieldEditList.forEach((item) => {
      this.fetchupdateOrderLoad(item);
    });*/
  }

  private fetchupdateOrderLoad(data, itemSelect) {
    this.updateOrderService.updateBaseUnit(data).subscribe({
      next: (res: any) => {
        this.snackBar.open("Se actualizo exitosamente el material", "Cerrar", {
          duration: 3000,
        });
        itemSelect.soldQuantity = res.updatedDetail.soldQuantity;
        itemSelect.baseQuantity = res.updatedDetail.baseQuantity;
        itemSelect.pararellQuantity = res.updatedDetail.pararellQuantity;
        this.distributionSpare();
        // TODO: verify this typing of trip attributes response from api, not changes to keep the code working
        // @ts-ignore
        this.fetchOrderGroudMaterial(this.selectedMR.id, false);
        this.selectGroupUnified = null;
        this.selectItemDistribution = null;
      },
      error: (error) => {
        this.snackBar.open(error.error.message, "Cerrar", { duration: 3000 });
      },
    });
  }

  private groupBySerial(data: any) {
    const grouped = data.reduce((acc, item) => {
      const key = item.serial;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});

    return Object.entries(grouped).map(([serial, items]: [string, any[]]) => {
      const totalSpare = items.reduce(
        (sum, item) => sum + (item.spare || 0),
        0
      );
      return {
        noDto: {
          serial,
          code: items[0].externalKeys?.code,
          previousTransactions: items[0].previousTransactions
        },
        totalSpare,
        items,
      };
    });
  }

  private fetchOrderGroudMaterial(id: string, isOpen: boolean) {
    this.salesDistributionService.getOrdersGruopByMaterial(id).subscribe({
      next: (res: DistributionGroupedByTrip[]) => {
        const listDataUnified = res.map((item) => {
          const totalBaseQuantity = parseFloat(
            item.orderdetail.reduce(
              (sum, item) => sum + (item.baseQuantity || 0),
              0
            ).toFixed(3)
          );

          const resultMisSper = parseFloat((item.totalBaseQuantity - totalBaseQuantity).toFixed(3));

          if (resultMisSper >= 0) {
            item.spare = resultMisSper;
            item.missing = 0;
          } else {
            item.missing = -resultMisSper;
            item.spare = 0;
          }
          return item;
        });


        this.deliveryGroupUnified.data = this.groupBySerial(listDataUnified);

        // this.totalItemsMaterial = res.total;
        // setTimeout(() => {
        // this.paginatorMaterial.length = this.totalItemsMaterial;
        //});

        if (isOpen) {
          this.openDistributionModal();
        }
      },
      error: (error) => {
      },
    });
  }

  public validateInput(event: any, item: any) {
    let value = event //.target.value;

    // Permite solo números con máximo 3 decimales
    value = value.replace(/[^0-9.]/g, "");

    // Evita múltiples puntos
    value = value.replace(/(\..*?)\..*/g, "$1");

    // Limita a 3 decimales
    value = value.replace(/^(\d*\.\d{0,3}).*$/, "$1");

    // Elimina ceros iniciales innecesarios (excepto antes del punto)
    value = value.replace(/^0+(?=\d)(?!\.)/, "");

    // Si no tiene punto decimal, agrégale ".0"
    if (value && !value.includes(".")) {
      value += ".0";
    }

    let numericValue = parseFloat(value);

    if (item.selectedUnit === UnitOfMeasureEnum.UMB) {
      item.baseQuantity = numericValue;
    } else if (item.selectedUnit === UnitOfMeasureEnum.UMP) {
      item.pararellQuantity = numericValue;
    }
  }

  public inputCancelUMB(itemSelect: any) {
    this.distributionSpare();
    itemSelect.edit = false;
  }

  public inputSaveUMB(itemSelect: any) {
    itemSelect.edit = itemSelect.edit ? false : true;
    itemSelect.soldQuantity = itemSelect.baseQuantity;
    itemSelect.pararellQuantity =
      itemSelect.baseQuantity * itemSelect.pararellConversionFactor;

    const totalBaseQuantity = +this.selectItemDistribution.orderdetail.reduce(
      (sum, item) => sum + (item.baseQuantity || 0),
      0
    );

    const resultMisSper =
      this.selectItemDistribution.totalBaseQuantity - totalBaseQuantity;

    if (resultMisSper >= 0) {
      this.selectItemDistribution.spare = resultMisSper;
      this.selectItemDistribution.missing = 0;
    } else {
      this.selectItemDistribution.missing = -resultMisSper;
      this.selectItemDistribution.spare = 0;
    }

    if (!itemSelect.edit) {
      const filterDeliveryUndified = this.deliveryUnifieldEditList.filter(
        (item: any) => item._id === itemSelect._id
      );

      if (filterDeliveryUndified.length > 0) {
        this.deliveryUnifieldEditList[0].quantity = itemSelect.baseQuantity;
      } else {
        this.deliveryUnifieldEditList.push({
          _id: itemSelect._id,
          position: itemSelect.position,
          materialId: this.selectItemDistribution.material._id,
          quantity: itemSelect.baseQuantity,
        });
      }

      this.deliveryGroupMaterialUnified.data = [
        ...this.deliveryGroupMaterialUnified.data,
      ];

      if (!itemSelect.selectedUnit) {
        itemSelect.selectedUnit = 'UMB';
      }

      this.dataSourceDistributionItemDetail.data = [
        ...this.dataSourceDistributionItemDetail.data,
      ];
    }

    this.fetchupdateOrderLoad({
      _id: itemSelect._id,
      position: itemSelect.position,
      materialId: this.selectItemDistribution.material._id,
      quantity: itemSelect.baseQuantity,
      type: itemSelect.selectedUnit ?? 'UMB'
    }, itemSelect);
  }

  private fetchupdateOrdeConfirmation(data: any) {
    this.updateOrderService.updateOutboundDelivery(data).subscribe({
      next: (res: any) => {
        this.snackBar.open("Se guardo exitosamente", "Cerrar", {
          duration: 3000,
        });

        this.onLoandDelivery();
      },
      error: (error) => {
        this.snackBar.open(error.error.message, "Cerrar", { duration: 3000 });
      },
    });
  }

  private fetchOrderBySerial(serial: string) {
    this.salesDistributionService.getOrderBySerial(serial).subscribe({
      next: (res: any) => {
        this.detailOrderUnified = [res.data];
        this.openDistributionModalDetails(serial);
      },
      error: (error) => {
        this.snackBar.open(error.error.message, "Cerrar", { duration: 3000 });
      },
    });
  }


  openSoldToEmptyDocument() {
    if (!this.selectItemDistribution) {
      this.snackBar.open("Debe seleccionar un documento", "Cerrar", { duration: 3000 });
      return;
    }

    let send = {
      entryDeliverySerials: this.selectItemDistribution.serial
    }

    this.orederService.getCustomersByDocument(send).subscribe(
      (res) => {
        this.soldToList = res || [];
        this.selectedSoldTo = null;
        this.detail.selectedUnit = null;
        this.soldToEmptyDialogRef = this.dialog.open(this.soldToEmptyDocument, {
          width: '500px'
        });
      });
  }

  selectSoldTo(soldTo: any) {
    this.selectedSoldTo = soldTo;
    this.detail = {
      selectedUnit: null,
      baseQuantity: null,
      pararellQuantity: null
    };
  }

  saveSoldTo() {
    if (!this.selectedSoldTo || !this.detail.selectedUnit || !this.detail.baseQuantity) {
      this.snackBar.open("Debe seleccionar un cliente y completar los campos requeridos", "Cerrar", { duration: 3000 });
      return;
    }

    const data = {
      eeDocumentDoc: this.selectItemDistribution.serial,
      materialId: this.selectItemDistribution.material._id,
      esDocument: this.selectedSoldTo.serial,
      quantity: this.detail.selectedUnit == 'UMP' ? this.detail.pararellQuantity : this.detail.baseQuantity,
      type: this.detail.selectedUnit ?? 'UMB'
    };

    this.orederService.postCustomerAddDocument(data).subscribe({
      next: (res) => {
        this.snackBar.open("Se guardó exitosamente", "Cerrar", { duration: 3000 });
        this.soldToEmptyDialogRef?.close();
        this.onLoandDelivery();
        this.distributionSpare();
        // TODO: verify this typing of trip attributes response from api, not changes to keep the code working
        // @ts-ignore
        this.fetchOrderGroudMaterial(this.selectedMR.id, false);
        this.selectGroupUnified = null;
        this.selectItemDistribution = null;
        this.selectNew.set(res.newDetail)
      },
      error: (error) => {
        this.snackBar.open(error.error.message, "Cerrar", { duration: 3000 });
      },
    });
  }

  isThereOrderSourceTransaction(element: any): boolean {
    return element.type.code == DocumentTypeEnum.DOCUMENTO_DE_CARGA && Array.isArray(element?.sourceTransactions) &&
      element.sourceTransactions.some(t => t?.type?.code === DocumentTypeEnum.PEDIDO);
  }


  goToOrder(element: OrderAttributes) {
    if (element?.serial && Array.isArray(element?.sourceTransactions)) {
      const orderIds = element.sourceTransactions
        .filter(t => t?.type?.code === DocumentTypeEnum.PEDIDO)
        .map(t => t.serial).toString();

      if (orderIds.length > 0) {
        const queryParams = { orderIds: orderIds };
        const urlTree = this.router.createUrlTree(['master', 'sales', 'orders-list'], { queryParams });
        const absoluteUrl = window.location.origin + this.router.serializeUrl(urlTree);
        window.open(absoluteUrl, '_blank');
      }
    }
  }

  //  openMapWindow() {
  //   this.userRequestedMap = true;
  //   this.windowState.closeWindow(true); // Destruye primero
  //   setTimeout(() => {
  //     this.windowState.openWindow();
  //     if (this.agendaMap) {
  //       this.agendaMap.initMap();
  //     }
  //   }, 50);
  // }

  // Abrir ventana de entregas
  openDeliveriesMapWindow() {
    if (!this.selectedDelivery?.length) return;
    this.userRequestedMap = true;
    this.windowState.closeWindow('deliveries', true);
    setTimeout(() => {
      this.windowState.openWindow('deliveries');
      if (this.agendaMap) {
        this.agendaMap.initMap();
      }
    }, 50);
  }

  /**
     * Obtiene los materiales agrupados por cliente con paginación del backend
     */
  private async getOrdersGroupedByCustomersWithMaterials(
    pageSizeCustom: number,
    pageIndexCustom: number,
    sortActiveCustom: string,
    tripId: number,
    document_type: string[]
  ): Promise<void> {
    const sortDirection = SortDirectionEnum.ASC;
    this.isLoadingClientMaterials = true;

    try {
      const response = await lastValueFrom(this.orederService
        .getOrdersGroupedByCustomersWithMaterials(
          {
            currentPage: pageIndexCustom + 1, // La API espera páginas basadas en 1
            limitPerPage: pageSizeCustom,
            search: this.searchDocument,
            sort: sortActiveCustom as keyof OrderAttributes,
            sortDirection: sortDirection,
          },
          tripId,
          document_type
        )
        .pipe(take(1))
      );

      // Extraer los datos ya agrupados de la respuesta
      this.clientMaterialsSummary = response?.data?.[0]?.data || [];
      this.totalItemsClientMaterials = response?.data?.[0]?.pageInfo?.[0]?.total || 0;


    } catch (error) {
      this.snackBar.open("Error al obtener los materiales agrupados por cliente", "Cerrar", { duration: 3000 })
      this.clientMaterialsSummary = [];
      this.totalItemsClientMaterials = 0;
    } finally {
      this.isLoadingClientMaterials = false;
    }
  }

  /**
   * Obtiene los materiales agrupados con clientes debajo usando el nuevo endpoint
   */
  private async getGroupedMaterialsWithCustomers(
    pageSizeCustom: number,
    pageIndexCustom: number,
    sortActiveCustom: string,
    tripId: number,
    document_type: string[]
  ): Promise<void> {
    const sortDirection = SortDirectionEnum.ASC;
    this.isLoadingClientMaterials = true;

    try {
      const response = await lastValueFrom(this.orederService
        .getGroupedMaterialsByCustomers(
          {
            currentPage: pageIndexCustom + 1, // La API espera páginas basadas en 1
            limitPerPage: pageSizeCustom,
            search: this.searchDocument,
            sort: sortActiveCustom as keyof OrderAttributes,
            sortDirection: sortDirection,
          },
          tripId,
          document_type
        )
        .pipe(take(1))
      );

      // Asignar los datos agrupados de materiales con clientes
      this.groupedMaterialsWithCustomers = response?.data?.[0]?.data || [];
      this.totalItemsClientMaterials = response?.data?.[0]?.pageInfo?.[0]?.total || 0;

    } catch (error) {
      this.snackBar.open(error.error.message || "Error al obtener grupo de materiales por socio de negocios.", "Cerrar", { duration: 5000 });
      this.groupedMaterialsWithCustomers = [];
      this.totalItemsClientMaterials = 0;
    } finally {
      this.isLoadingClientMaterials = false;
    }
  }

  /**
   * Maneja el evento de cambio de página del componente hijo
   */
  onClientMaterialsPageChange(event?: { pageIndex: number; pageSize: number; sortActive?: string }) {
    this.pageIndexClientMaterials = event?.pageIndex ?? this.pageIndexClientMaterials;
    this.pageSizeClientMaterials = event?.pageSize ?? this.pageSizeClientMaterials;

    // Recargar datos con nueva paginación
    this.loadClientMaterialsData();
  }

  /**
   * Carga los datos de materiales por cliente
   */
  private loadClientMaterialsData() {

    if (this.selectedMR?.id) {
      this.getGroupedMaterialsWithCustomers(
        this.pageSizeClientMaterials,
        this.pageIndexClientMaterials,
        'shipTo.name',
        this.selectedMR.id,
        this.documentTypesForClientsGroupedByMaterial
      );
    }
  }

  /**
   * Abre facturas relacionadas a los pagos
   * @param element 
   */
  async openHistory(element: GroupedPayment) {
    try {
      const dialogRef = this.dialog.open(MaterialHistoryComponent, {
        width: "90%",
        data: {
          element: { payments: element.originalPayments }, // Pass payments instead of orders
          UMPActive: this.UMPActive,
          hideCheckColumn: true,
          isPaymentModal: true, // Flag to indicate payment context
          paymentAmount: element.totalPaying,
          paymentInfo: {
            paymentType: element.paymentType,
            bank: element.bank,
            account: element.account,
            totalOverPayment: element.totalOverPayment
          }
        },
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result !== undefined && result !== "Close") {
        }
      });

    } catch (error) {
      this.snackBar.open(error.error.message || "Error al abrir historial.", "Cerrar", { duration: 5000 });
    }
  }

  //region Pedidos mapa
  openMap(data) {
    this.dialog.open(MapModalComponent, {
      width: '90%',
      //height: '80%',
      data: data
    });
  }

  async openDocumentsMapWindow(document: MonitorDocumentTypeEnum) {
    let documents: DocumentTypeMonitor[] = [];
    if (document === MonitorDocumentTypeEnum.PROGRESS) {
      documents = this.groupDocuments ?? await this.fechtDocumentTypes();
    }

    const data: MapModalInputData = {
      type: MapModalTypeEnum.GROUPED_WITH_FILTER,
      useDate: document !== MonitorDocumentTypeEnum.VISIT ? true : false,
      tripId: this.selectedMR?.id,
      element: null,
      document: document,
      groupDocuments: documents.map(d => d.typeCode),
      map: {
        displayMode: 'drawer',
        captions: {
          title: document === MonitorDocumentTypeEnum.PROGRESS ? 'Documentos' :
            document === MonitorDocumentTypeEnum.DELIVERY ? 'Entregas' :
              document === MonitorDocumentTypeEnum.VISIT ? 'Recorrido' : 'Pedidos'
        }
      },
      filters: {
        mode: MapFilterTypeEnum.NORMAL,
        filters: {
          statusIds: document === MonitorDocumentTypeEnum.DOCUMENT ? [StatusEnum.ACTIVE, StatusEnum.ORDER_DELIVERED, StatusEnum.ORDER_PARTIAL_DELIVERED, StatusEnum.ORDER_DELIVERY_REJECTED] : undefined,
          isDirectSale: document === MonitorDocumentTypeEnum.DELIVERY ? true : undefined
        }
      }
    }

    this.openMap(data)
  }

  openModalVisit(element, type): void {
    if (this.isNew) {
      const data: MapModalInputData = {
        type: MapModalTypeEnum.SIMPLE_TWO,
        tripId: this.selectedMR?.id,
        element: element,
        document: MonitorDocumentTypeEnum.NONE,
        groupDocuments: [],
        map: {
          displayMode: 'drawer',
          captions: { title: 'Ubicación' }
        }
      }

      this.openMap(data)
    } else {
      this.dialog.open(ModalMapComponent, {
        width: "90%",
        data: { element, type: type },
        disableClose: true,
      });
    }
  }
  //#endregion

  getTooltip(el: TripAttributes & { responsible?: { externalKeys: { code?: string }; name?: string, personNumber?: string } }): string {
    const rutaCode =
      el?.subRoute?.externalKeys?.code ?? el?.subRoute?.model ?? "-";
    const rutaName = el?.subRoute?.name ?? "-";
    const user = el?.user?.user_login?.username ?? "-";

    const person = el?.responsible?.personNumber
      ? `${el.responsible.personNumber} - `
      : "";
    const bpCode = el?.responsible?.externalKeys?.code ?? "";
    const bpName = el?.responsible?.name ?? "-";

    return [
      `Ruta: ${rutaCode} | ${rutaName}`,
      `Usuario: ${user}`,
      `Responsable: ${person}${bpCode} ${bpName}`.trim(),
    ].join("\n");
  }

  // Métodos para manejar viajes pineados

  /**
   * Verifica si un viaje está pineado
   */
  public isTripPinned(tripId: number): boolean {
    return this.pinnedTripsService.isTripPinned(tripId);
  }

  /**
   * Alterna el estado pineado de un viaje
   */
  public onTogglePin(trip: TripAttributes, event: Event): void {
    // Prevenir que se expanda/colapse la fila
    event.stopPropagation();

    const tripId = trip.id;
    const wasPinned = this.pinnedTripsService.isTripPinned(tripId);

    if (!wasPinned && this.pinnedTripsService.hasReachedLimit()) {
      this.snackBar.open(`No se pueden pinear más de 20 viajes`, 'Cerrar', { duration: 3000 });
      return;
    }

    const success = this.pinnedTripsService.togglePinTrip(tripId);

    if (success) {
      const action = wasPinned ? 'despineado' : 'pineado';
      this.snackBar.open(`Viaje ${tripId} ${action}`, 'Cerrar', { duration: 2000 });
      // Actualizar la vista
      this.cdr.detectChanges();
    }
  }

  /**
   * Obtiene la clase CSS para el botón de pin
   */
  public getPinButtonClass(tripId: number): string {
    return this.isTripPinned(tripId) ? 'pin-button-active' : 'pin-button-inactive';
  }

  /**
   * Obtiene el ícono para el botón de pin
   */
  public getPinIcon(tripId: number): string {
    return this.isTripPinned(tripId) ? 'push_pin' : 'push_pin';
  }

  /**
   * Maneja el click en el header del pin para abrir el modal de configuración
   */
  public onPinHeaderClick(event: Event): void {
    event.stopPropagation();
    this.openPinnedModal.emit();
  }

  // ============================================================================
  // SMART GRID INITIALIZATION METHODS - Pedidos por Cliente
  // ============================================================================

  /**
   * Initialize column definitions for the main Pedidos por Cliente grid
   */
  private initializeChargeOrdersColumnDefs(): void {
    this.chargeOrdersColumnDefs = [
      // 1. Document Number Column
      {
        field: "serial" as any,
        colId: "nroDocumento",
        headerName: "Nro. Documento",
        width: 180,
        minWidth: 150,
        sortable: true,
        filterable: true,
        cellRenderer: OrderDocumentCellRendererComponent,
      },

      // 2. Business Partner Column
      {
        colId: "businessPartner",
        headerName: "Pagador/Receptor",
        width: 250,
        minWidth: 200,
        sortable: false,
        filterable: false,
        cellRenderer: OrderBusinessPartnerCellRendererComponent,
      },

      // 3. Delivery DateTime Column
      {
        field: "deliveryDateTime" as any,
        colId: "dateHourDelivery",
        headerName: "Fecha y Hora de Entrega",
        width: 200,
        minWidth: 180,
        sortable: true,
        filterable: true,
        cellRenderer: DeliveryDateTimeCellRendererComponent,
        filterOptions: {
          displayNameGetter: (value: any) => {
            if (!value) return '-';
            const pipe = new DatePipe('en-US');
            return pipe.transform(value, 'dd-MM-yyyy HH:mm:ss') ?? '-';
          }
        },
      },

      // 4. Total Column
      {
        field: "subTotal" as any,
        colId: "total",
        headerName: "Total",
        width: 140,
        minWidth: 120,
        sortable: true,
        filterable: true,
        cellRenderer: DecimalCellRendererComponent,
        filterOptions: {
          displayNameGetter: (value: any) => {
            if (value == null || value === undefined) return '-';
            const pipe = new DecimalPipe('en-US');
            return pipe.transform(value, '1.2-2') ?? '-';
          }
        },
        cellClass: "text-right",
        headerClass: "text-right",
      },
    ];
  }

  /**
   * Initialize column definitions for the nested material details grid
   */
  private initializeMaterialDetailsColumnDefs(): void {
    this.materialDetailsColumnDefs = [
      // 1. Material Column
      {
        colId: "material",
        headerName: "Material",
        width: 250,
        minWidth: 200,
        sortable: true,
        filterable: true,
        cellRenderer: MaterialDetailsCellRendererComponent,
      },

      // 2. Total Column
      {
        field: "total" as any,
        headerName: "Total",
        width: 140,
        minWidth: 120,
        sortable: true,
        filterable: true,
        cellRenderer: DecimalCellRendererComponent,
        filterOptions: {
          displayNameGetter: (value: any) => {
            if (value == null || value === undefined) return '-';
            const pipe = new DecimalPipe('en-US');
            return pipe.transform(value, '1.2-2') ?? '-';
          }
        },
        cellClass: "text-right",
        headerClass: "text-right",
      },

      // 3. Price Column
      {
        field: "unitPrice" as any,
        colId: "price",
        headerName: "Precio",
        width: 140,
        minWidth: 120,
        sortable: true,
        filterable: true,
        cellRenderer: DecimalCellRendererComponent,
        filterOptions: {
          displayNameGetter: (value: any) => {
            if (value == null || value === undefined) return '-';
            const pipe = new DecimalPipe('en-US');
            return pipe.transform(value, '1.2-2') ?? '-';
          }
        },
        cellClass: "text-right",
        headerClass: "text-right",
      },

      // 4. Quantity Column
      {
        colId: "cntLoad",
        headerName: "Cantidad",
        width: 220,
        minWidth: 200,
        sortable: false,
        filterable: false,
        cellRenderer: QuantityUMPCellRendererComponent,
        cellRendererParams: {
          UMPActive$: this.UMPActive$,
        },
      },
    ];
  }

 
}
